const de = {
  'header.customerService': 'Kundenservice',
  "header.freeShipping": "Kostenloser Versand ab {n} €",
  'header.login': 'Anmelden',
  'header.admin': 'Verwaltung',
  'header.myAccount': 'Mein Konto',
  'header.myWishlist': 'Meine Wunschliste',
  'header.myOrders': 'Meine Bestellungen',
  'header.logout': 'Abmelden',
  'header.parts': 'Ersatzteile',
  'header.wholeCategory': 'Gesamte Kategorie {name} →',
  'header.brands': 'Marken',
  'header.guides': 'Ratgeber',
  'header.topGuides': 'Meistgelesene Ratgeber',
  'header.allGuides': 'Alle Ratgeber',
  'header.allBrandsAZ': 'Alle Marken von A bis Z ({count})',
  'header.removeVehicle': 'Fahrzeug entfernen',
  'header.createAccount': 'Konto erstellen',
  'header.brandsAZ': 'Marken von A bis Z',
  'header.contact': 'Kontakt',
  'header.language': 'Sprache',
  'header.searchPlaceholder': 'Teil, Marke oder Referenz suchen',
  'header.searching': 'Suche...',
  'header.noResults': 'Keine Ergebnisse für „{term}“',
  'header.openProduct': 'Produktseite öffnen',
  'header.matchesRef': 'Entspricht der {kind}Ref.',

  'footer.tagline': '6,7 Millionen Autoteile an einem Ort',
  'footer.contactUs': 'Kontaktieren Sie uns',
  'footer.contact': 'Kontakt',
  'footer.shipping': 'Versand & Sendungsverfolgung',
  'footer.returns': 'Garantie & Rückgabe',
  'footer.about': 'Über uns',
  'footer.sitemap': 'Sitemap',
  'footer.budget': 'Wartungsbudget nach Modell',
  'cookies.title': 'Cookies und Reichweitenmessung',
  'cookies.text': 'Wir verwenden für den Betrieb der Website notwendige Cookies (Warenkorb, Anmeldung) und – mit Ihrer Zustimmung – Analyse-Cookies (Google Analytics, PostHog), um OTOPIECES.COM zu verbessern. Keine Werbung. Ihre Wahl wird 6 Monate gespeichert.',
  'cookies.accept': 'Alle akzeptieren',
  'cookies.refuse': 'Ablehnen',
  'cookies.customise': 'Anpassen',
  'cookies.save': 'Auswahl speichern',
  'cookies.necessary': 'Notwendige Cookies',
  'cookies.necessaryHint': 'immer aktiv (Warenkorb, Sitzung, Einstellungen)',
  'cookies.analytics': 'Reichweitenmessung',
  'cookies.analyticsHint': 'anonyme Nutzungsstatistiken (Google Analytics, PostHog)',
  'cookies.close': 'Schließen',
  'cookies.manage': 'Cookies verwalten',
  'cookies.statusOn': 'Reichweitenmessung: aktiviert. Sie können Ihre Wahl jederzeit ändern.',
  'cookies.statusOff': 'Reichweitenmessung: abgelehnt. Nur notwendige Cookies werden verwendet.',
  'cookies.statusNone': 'Sie haben noch keine Wahl getroffen: nur notwendige Cookies sind aktiv.',
  'footer.securePayments': 'Sichere Zahlungen:',
  'footer.fastShipping': "Lieferung in ganz Europa",
  'footer.rights': '© 2026 OTOPIECES.COM. Alle Rechte vorbehalten.',
  'footer.trademarks': 'Alle Marken sind Eigentum ihrer jeweiligen Inhaber.',

  'common.ref': 'Art.-Nr.',
  'common.addToCart': 'In den Warenkorb',
  'common.free': 'Kostenlos',
  'common.subtotal': 'Zwischensumme',
  'common.shipping': 'Versand',
  'common.total': 'Gesamt',
  'common.vatIncluded': 'inkl. MwSt.',
  'common.back': 'Zurück',
  'common.continueShopping': 'Weiter einkaufen',
  'common.outOfStock': 'Nicht vorrätig',
  'common.inStock': 'Auf Lager',
  'common.lowStock': 'Nur noch {n} auf Lager',
  'common.supplierStock': 'Beim Lieferanten · innerhalb von {n} Tagen',
  'common.compatible': 'Kompatibel',
  'common.cancel': 'Abbrechen',
  'common.apply': 'Anwenden',
  'common.home': 'Startseite',
  'common.breadcrumb': 'Navigationspfad',
  'common.unit': 'Einzeln',
  'common.perUnit': '/ Stück',
  'common.discount': 'Rabatt ({code})',
  'common.packAvailable': 'Erhältlich als {label}',
  'common.equivalentOther': 'Äquivalent einer anderen Marke (gleiche OEM-Nr.)',
  'common.oem': 'OEM-',
  'common.alternative': 'Alternativ-',
  'common.bestPrice': 'Bester Marktpreis',
  'common.bestPriceTitle': 'Preis verglichen mit {n} Mitbewerber(n){date}: OTOPIECES ist am günstigsten.',
  'common.onDate': ' am {date}',

  'stock.out': 'Nicht vorrätig',
  'stock.supplier': { one: 'Beim Lieferanten verfügbar — Versand innerhalb von {n} Tag', other: 'Beim Lieferanten verfügbar — Versand innerhalb von {n} Tagen' },
  'stock.low': 'Nur noch {n} auf Lager',
  'stock.lowSupplier': ' (+{s} beim Lieferanten innerhalb von {lead} Tagen)',
  'stock.in': 'Auf Lager',

  'product.notFound': 'Produkt nicht gefunden',
  'product.backHome': 'Zurück zur Startseite',
  'product.allParts': 'Alle Teile von {brand}',
  'product.manufacturerRef': 'Hersteller-Nr.:',
  'product.equivalentRef': 'Äquivalente Referenz',
  'product.oemRef': 'OEM-Herstellerreferenz',
  'product.moreOem': { one: '+{n} weitere OEM-Nr.', other: '+{n} weitere OEM-Nrn.' },
  'product.reviews': { one: '{n} Bewertung', other: '{n} Bewertungen' },
  'product.compatibleWith': 'Kompatibel mit Ihrem ',
  'product.notGuaranteed': 'Nicht garantiert für Ihren ',
  'product.ttcExclShipping': 'inkl. MwSt., zzgl. Versand',
  'product.tierBadge': '−{pct}% ab {n}',
  'product.cheaperAlt': 'Alternative ab {price} € von {brand}',
  'product.cheaperAltCompat': 'Passende Alternative ab {price} € von {brand}',
  'product.soldBy': 'Verkauft im',
  'product.soldByDetail': 'Verkauft im {n}er-Pack{label} — {total} € {unitLabel}, d. h. {unit} € / Stück',
  'product.theN': 'pro {n}',
  'product.totalFor': 'Gesamt für {n}:',
  'product.insteadOf': 'statt {price} €',
  'product.outOfStockHint': 'Vorübergehend nicht vorrätig',
  'product.photoCheck': 'Mein Teil per Foto prüfen',
  'product.added': 'In den Warenkorb gelegt',
  'product.addPack': '{qty}{label} hinzufügen',
  'product.viewCart': 'Warenkorb ansehen',
  'product.delivery': 'Lieferung in 2-5 Tagen',
  "product.deliverySub": "Kostenlos ab {n} €",
  'product.return': '14 Tage Rückgabe',
  'product.returnSub': 'Geld-zurück-Garantie',
  'product.warranty': '2 Jahre Garantie',
  'product.warrantySub': 'Zertifizierte Teile',
  'product.description': 'Beschreibung',
  'product.faqTitle': 'Häufige Fragen zu diesem Produkt',
  'product.share': 'Teilen',
  'product.shareCopy': 'Link kopieren',
  'product.shareCopied': 'Link kopiert',
  'product.specs': 'Technische Daten',
  'product.compatibleVehicles': 'Kompatible Fahrzeuge',
  'product.universal': 'Universalprodukt: kompatibel mit allen Fahrzeugen.',
  'product.allModels': 'Alle Modelle',
  'spec.manufacturer': 'Hersteller',
  'spec.reference': 'Referenz',
  'spec.otherRefs': 'Weitere Referenzen',
  'spec.oemRefs': 'OEM-Referenzen',
  'spec.category': 'Kategorie',
  'product.alsoIn': 'Auch zu finden in',
  'product.relatedSubs': 'Weitere Teile: {cat}',
  'product.relatedAll': 'Ganze Kategorie {cat}',
  'product.relatedMore': 'Alle anzeigen (+{n})',
  'product.relatedLess': 'Weniger anzeigen',
  'product.relatedVehicles': 'Passende Teile nach Fahrzeug',
  'product.guides': 'Ratgeber: {part}',
  'product.readGuide': 'Ratgeber lesen',
  'cat.popularModels': '{part} für die gefragtesten Modelle',
  'spec.features': 'Merkmale',
  'spec.ean': 'EAN-Nummer',
  'spec.condition': 'Zustand',
  'spec.new': 'Neu',
  'spec.soldBy': 'Verkauft im',
  'spec.packagings': 'Verpackungseinheiten',
  'spec.avgRating': 'Durchschnittliche Bewertung',
  'spec.avgRatingValue': '{r} / 5 ({n} Bewertungen)',
  'spec.warranty': 'Garantie',
  'spec.warrantyValue': 'mindestens 2 Jahre',
  'spec.availability': 'Verfügbarkeit',

  'pack.title': 'Verpackungseinheit',
  'pack.units': '{n} Stück · {price} € / Stück',
  'pack.unitPrice': 'Einzelpreis',
  'pack.insufficient': ' · nicht genug Lagerbestand',
  'tiers.title': 'Staffelpreise — mehr kaufen, weniger zahlen',
  'tiers.quantity': 'Menge',
  'tiers.unitPrice': 'Einzelpreis',
  'tiers.saving': 'Ersparnis',
  'tiers.range': '{a} bis {b}',
  'tiers.andMore': 'ab {a}',
  'tiers.note': 'Rabatt wird im Warenkorb automatisch auf den Einzelpreis angewendet.',
  'pro.ht': 'd. h. {price} € netto',
  'pro.discount': 'Profipreis −{pct} %: {price} € brutto im Warenkorb',
  'wishlist.added': 'Zur Wunschliste hinzugefügt',
  'wishlist.removed': 'Von der Wunschliste entfernt',
  'wishlist.error': 'Wunschliste konnte nicht aktualisiert werden',
  'wishlist.remove': 'Von der Wunschliste entfernen',
  'wishlist.add': 'Zur Wunschliste hinzufügen',
  'wishlist.inList': 'Auf meiner Liste',
  'wishlist.addToList': 'Zu meiner Liste',
  'faq.askPrompt': 'Eine Frage zu diesem Teil? Stellen Sie sie, wir antworten innerhalb von 24 h.',
  'faq.ask': 'Frage stellen',
  'faq.title': 'Häufige Fragen',
  'faq.seeAll': 'Alle Fragen ansehen ({n})',
  'faq.answerFrom': 'Antwort von {author}',
  'tyre.howMany': 'Wie viele Reifen?',
  'tyre.one': '1 Reifen',
  'tyre.set4': 'Satz mit 4 Reifen',
  'tyre.n': '{n} Reifen',
  'tyre.perTyre': '/ Reifen',
  'tyre.insufficient': 'Nicht genug Bestand für einen 4er-Satz — kontaktieren Sie uns für Nachbestellung.',
  'equiv.title': 'Dieses Teil gibt es auch von anderen Marken',
  'equiv.count': { one: '{n} Alternative', other: '{n} Alternativen' },
  'equiv.cheaper': { one: ' · {n} günstiger', other: ' · {n} günstiger' },
  'equiv.compare': 'Nebeneinander vergleichen ({n})',
  'similar.title': 'Ähnliche Produkte',
  'similar.sub': '— {category} anderer Marken, passend für dieselben Fahrzeuge',
  'similar.subVehicle': '— passend für Ihren {vehicle}',
  'recent.title': 'Zuletzt angesehen',
  'recent.clear': 'Löschen',
  'fitments.count': '{n} Motorisierung(en) · {b} Marke(n)',
  'fitments.filter': 'Filtern (Marke, Modell, Motor)',
  'fitments.models': { one: '· {n} Modell', other: '· {n} Modelle' },
  'fitments.noMatch': 'Keine Motorisierung passt zu „{q}“.',
  'reviews.title': 'Kundenbewertungen',
  'reviews.outOf5': 'von 5',
  'reviews.loginPrompt': ', um ein bestelltes Produkt zu bewerten.',
  'reviews.login': 'Anmelden',
  'reviews.already': 'Danke, Sie haben dieses Produkt bereits bewertet.',
  'reviews.rewardTitle': 'Bewerten Sie das Produkt und erhalten Sie -{percent} % auf Ihre nächste Bestellung',
  'reviews.rewardText': 'Nur für Kunden, die dieses Produkt gekauft haben. Ihr persönlicher Code wird Ihnen zugeschickt, sobald Ihre Bewertung veröffentlicht ist (gültig {days} Tage).',
  'reviews.rewardLogin': 'Anmelden, um eine Bewertung abzugeben',
  'reviews.rewardWrite': 'Bewertung schreiben',
  'reviews.rewardAfterPurchase': 'Verfügbar nach dem Kauf dieses Produkts.',
  'reviews.rewardThanks': 'Vielen Dank für Ihre Bewertung! Hier ist Ihr Code über -{percent} %',
  'reviews.rewardCopy': 'Kopieren',
  'reviews.rewardCopied': 'Code kopiert',
  'reviews.rewardValidity': 'Im Warenkorb eingeben · gültig bis {date}, einmalig verwendbar.',
  'reviews.rewardUsed': 'Code bereits eingelöst — danke!',
  'reviews.rewardMinOrder': 'ab {amount} € Bestellwert',
  'reviews.customerPhotos': 'Fotos unserer Kunden ({n})',
  'reviews.customerPhotosSee': 'Bewertungen ansehen',
  'reviews.customerPhotosHint': 'Echte Fotos, die verifizierte Käufer mit ihrer Bewertung eingesendet haben. Zum Vergrößern klicken.',
  'reviews.yourRating': 'Ihre Bewertung *',
  'reviews.titleField': 'Titel',
  'reviews.titlePlaceholder': 'Zusammenfassung in wenigen Worten',
  'reviews.comment': 'Kommentar *',
  'reviews.commentPlaceholder': 'Qualität, Einbau, Preis-Leistung...',
  'reviews.published': 'Ihre Bewertung wurde veröffentlicht. Danke!',
  'reviews.empty': 'Noch keine Bewertungen. Teilen Sie als Erster Ihre Erfahrung!',
  'reviews.sortBy': 'Sortieren nach',
  'reviews.merchantCollected': 'Vom Händler erfasste Bewertung',
  'reviews.verified': 'Verifizierter Kauf',
  'reviews.replyFrom': 'Antwort von {author}',
  'reviews.sort.recent': 'Neueste',
  'reviews.sort.helpful': 'Hilfreichste',
  'reviews.sort.photos': 'Mit Fotos zuerst',
  'reviews.share': 'Teilen',
  'home.google.badge': { one: 'bei Google · {n} Bewertung', other: 'bei Google · {n} Bewertungen' },
  'brand.trust.title': 'Vertrauensscore',
  'brand.trust.summary': { one: '{n} verifizierte Bewertung zu {p} bewerteten Produkt(en)', other: '{n} verifizierte Bewertungen zu {p} bewerteten Produkt(en)' },
  'brand.trust.recommended': { one: '{n} von unseren Kunden empfohlenes Produkt', other: '{n} von unseren Kunden empfohlene Produkte' },
  'product.topBadge': 'Von unseren Kunden empfohlen',
  'product.topBadgeHint': '{r}/5 aus {n} verifizierten Bewertungen',
  'reviews.translate': 'Übersetzen',
  'reviews.translatedByAi': 'Automatisch übersetzt',
  'reviews.originalShown': 'Originaltext',
  'reviews.showOriginal': 'Original anzeigen',
  'reviews.showTranslation': 'Übersetzung anzeigen',
  'reviews.translateError': 'Übersetzung nicht verfügbar',
  'home.google.title': 'Google-Bewertung',
  'home.google.count': { one: '{n} Google-Bewertung', other: '{n} Google-Bewertungen' },
  'home.google.link': 'Alle Bewertungen auf Google ansehen',
  'reviews.pendingNotice': 'Danke! Ihre Bewertung ist eingegangen und wird nach einer kurzen Prüfung durch unser Team veröffentlicht.',
  'home.wall.kicker': 'Verifizierte Bewertungen',
  'home.wall.title': 'Autofahrer vertrauen uns',
  'home.wall.summary': { one: 'aus {n} verifizierten Bewertung', other: 'aus {n} verifizierten Bewertungen' },
  'reviews.shareText': 'Meine Bewertung {stars} für {product}: „{comment}“',
  'reviews.shareMine': 'Teilen Sie Ihre Bewertung mit Freunden:',
  'reviews.sort.best': 'Beste Bewertungen',
  'reviews.sort.worst': 'Schlechteste Bewertungen',
  'questions.title': 'Fragen & Antworten',
  'questions.ask': 'Frage stellen',
  'questions.placeholder': 'Z. B.: Passt dieses Teil zur Kombi-Version? Ist ein Spezialwerkzeug nötig?',
  'questions.name': 'Ihr Name *',
  'questions.email': 'Ihre E-Mail * (für die Antwort)',
  'questions.notice': 'Ihre Frage wird mit unserer Antwort veröffentlicht. ',
  'questions.notifyEmail': 'Sie werden per E-Mail benachrichtigt.',
  'questions.emailPrivate': 'Ihre E-Mail bleibt privat.',
  'questions.empty': 'Noch keine Fragen. Unsicher bei Kompatibilität oder Einbau? Fragen Sie uns!',
  'questions.yours': 'Ihre Frage',
  'questions.helped': 'War diese Antwort hilfreich?',
  'gallery.prev': 'Vorheriges Foto',
  'gallery.next': 'Nächstes Foto',

  'cart.title': { one: 'Ihr Warenkorb ({n} Artikel)', other: 'Ihr Warenkorb ({n} Artikel)' },
  'cart.empty': 'Ihr Warenkorb ist leer',
  'cart.discover': 'Unsere Produkte entdecken',
  'cart.units': 'Stück',
  'cart.soldBy': 'Verkauft im {n}er-Pack',
  'cart.proPrice': 'Profipreis',
  'cart.quantity': 'Menge',
  'cart.summary': 'Bestellübersicht',
  'cart.promoLogin': 'Gutscheincode? Melden Sie sich an, um ihn einzulösen.',
  "cart.freeShippingLeft": "Nur noch {amount} € bis zum kostenlosen Versand!",
  'cart.checkout': 'Zur Kasse',
  'cartDrawer.title': 'Mein Warenkorb',
  'cartDrawer.saveLater': 'Für später merken',
  'cartDrawer.fromWishlist': 'Aus Ihrer Wunschliste',
  'cartDrawer.goCart': 'Zum Warenkorb',
  'cartDrawer.checkout': 'Zur Kasse',
  'cart.loginToOrder': 'Anmelden zum Bestellen',
  'cart.guestNotice': 'Ihr Warenkorb bleibt bei Anmeldung oder Kontoerstellung erhalten.',
  "cart.freeShipping120": "Kostenloser Versand ab {n} €",
  'cart.return14': '14 Tage Rückgabe',
  'cart.securePayment': '100 % sichere Zahlung',
  'promo.placeholder': 'Gutscheincode',
  'promo.invalid': 'Ungültiger Code',
  'promo.remove': 'Code entfernen',
  'savings.title': 'Sie sparen',
  'alt.cheaper': 'Günstigere Alternative von {brand}',
  'alt.perUnit': '−{d} € / Stück',
  'alt.total': ', −{s} € insgesamt',
  'alt.replace': 'Ersetzen',
  'alt.replaced': '{name} ersetzt durch {alt}',
  'alt.error': 'Ersetzen nicht möglich',

  'checkout.backToCart': 'Zurück zum Warenkorb',
  'checkout.stepShipping': 'Lieferung',
  'checkout.stepPayment': 'Zahlung',
  'checkout.stepConfirmation': 'Bestätigung',
  'checkout.shippingAddress': 'Lieferadresse',
  'checkout.savedAddresses': 'Meine gespeicherten Adressen',
  'checkout.address': 'Adresse',
  'checkout.default': ' · Standard',
  'checkout.defaultBilling': ' · Standard-Rechnungsadresse',
  'checkout.manageAddresses': 'Adressen verwalten',
  'checkout.firstName': 'Vorname',
  'checkout.lastName': 'Nachname',
  'checkout.email': 'E-Mail',
  'checkout.phone': 'Telefon',
  'checkout.addressComplement': 'Adresszusatz',
  'checkout.complementPlaceholder': 'Wohnung, Etage, Gebäude...',
  'checkout.postalCode': 'Postleitzahl',
  'checkout.city': 'Stadt',
  'checkout.otherBilling': 'An eine andere Adresse fakturieren',
  'checkout.invoiceFor': '· Rechnung an {company}',
  'checkout.company': 'Firma (optional)',
  'checkout.vat': 'USt-IdNr. (optional)',
  'checkout.continue': 'Weiter zur Zahlung',
  'checkout.paymentMethod': 'Zahlungsart',
  'checkout.autoPayNotice': 'Lieferung an {address} (gespeicherte Adresse).',
  'checkout.autoPayEdit': 'Adresse ändern',
  'checkout.card': 'Kreditkarte',
  'checkout.cardInfo': 'Die Kartendaten werden bei der Bestätigung abgefragt.',
  'checkout.ssl': 'SSL-gesicherte Zahlung',
  'checkout.requested': { one: '{n} angefordert', other: '{n} angefordert' },
  'checkout.available': { one: '{n} verfügbar', other: '{n} verfügbar' },
  'checkout.fixCart': 'Warenkorb anpassen',
  'checkout.country': 'Lieferland', 'checkout.carrier': 'Versandart', 'checkout.relay': 'Paketshop', 'checkout.errCountry': 'In dieses Land liefern wir noch nicht. Bitte wählen Sie ein anderes Lieferland.', 'cart.shippingEstimate': 'Schätzung {country} · {carrier} — Versanddienst und Land wählen Sie im nächsten Schritt',
  'checkout.tyreFree': 'Versandkostenfrei ab 2 Reifen', 'checkout.relayPick': 'Paketshop wählen', 'checkout.relayChange': 'Paketshop ändern', 'checkout.relayRequired': 'Bitte wählen Sie einen Mondial-Relay-Paketshop auf der Karte.', 'checkout.relayTitle': 'Wählen Sie Ihren Paketshop',
  'checkout.weightTier': 'Gewichtstarif ({w} kg)',
  'checkout.processing': 'Verarbeitung...',
  'checkout.pay': '{amount} € bezahlen',
  'checkout.fastDelivery': 'Schnelle Lieferung',
  'checkout.fastDeliverySub': '2-5 Werktage',
  'checkout.securePayment': 'Sichere Zahlung',
  'checkout.sslSub': 'SSL 256-Bit',
  'checkout.warranty': 'Garantie',
  'checkout.warrantySub': 'mindestens 2 Jahre',
  'checkout.summary': 'Zusammenfassung',
  'checkout.qty': 'Menge: {n}',
  'checkout.fitting': 'Montage im Partnerzentrum',
  'checkout.totalHT': 'Gesamt netto (Profikonto)',
  'checkout.vatAmount': '· MwSt. {amount} €',
  'checkout.totalTTC': 'Gesamt brutto',
  'checkout.useWallet': 'Mein Guthaben verwenden ({amount} € verfügbar)',
  'checkout.walletUsed': 'Verwendetes Guthaben',
  'checkout.toPay': 'Noch zu zahlen',
  'checkout.confirmed': 'Bestellung bestätigt!',
  'checkout.thanks': 'Vielen Dank für Ihre Bestellung. Eine Bestätigungs-E-Mail wurde an {email} gesendet',
  'checkout.orderNumber': 'Bestellnummer',
  'checkout.deliveryTo': 'Lieferung an',
  'checkout.viewOrders': 'Meine Bestellungen ansehen',
  'checkout.errRequired': 'Das Feld „{field}“ ist erforderlich',
  'checkout.errPostal': 'Ungültige Postleitzahl (5 Ziffern erwartet)',
  'checkout.errEmail': 'Ungültige E-Mail-Adresse',
  'checkout.errPhone': 'Ungültige Telefonnummer (z. B. 06 12 34 56 78)',
  'checkout.errBilling': 'Unvollständige Rechnungsadresse (Name oder Firma, Adresse, PLZ, Stadt)',
  'checkout.errOrder': 'Fehler bei der Bestellung',
  'fitting.title': { one: 'Montage Ihres {n} Reifens', other: 'Montage Ihrer {n} Reifen' },
  'fitting.intro': 'Optional: Lassen Sie Ihre Reifen an ein Partnerzentrum liefern, das sie montiert und auswuchtet. Wählen Sie einen Termin im Kalender oder lassen Sie sich vom Zentrum kontaktieren.',
  'fitting.sorted': ' Zentren sortiert nach Zuverlässigkeit, dann nach Entfernung von {place}.',
  'fitting.none': 'Ohne Montage — Lieferung an die angegebene Adresse',
  'fitting.recommended': 'Empfohlen',
  'fitting.distance': '{km} km entfernt',
  'fitting.bestRated': 'Am besten bewertet in Ihrer Nähe',
  'fitting.hideReviews': 'Bewertungen ausblenden',
  'fitting.showReviews': 'Bewertungen ansehen',
  'fitting.reliable': 'Zuverlässiger Partner',
  'fitting.reliableTitle': 'Zentrum, das Termine schnell bestätigt',
  'fitting.online': 'Online-Termine',
  'fitting.perTyre': '/ Reifen',
  'fitting.hidden': { one: '{n} Partnerzentrum weiter als {km} km wird nicht angeboten.', other: '{n} Partnerzentren weiter als {km} km werden nicht angeboten.' },
  'fitting.selected': 'Ihre Reifen werden an {name} ({city}) geliefert. Montage + Auswuchten: {total} zur Bestellung hinzugefügt.',
  'slot.loading': 'Termine werden geladen…',
  'slot.unavailable': 'Dieses Zentrum hat noch keine Termine veröffentlicht: Es kontaktiert Sie nach der Bestellung zur Terminvereinbarung.',
  'slot.choose': 'Wählen Sie Ihren Termin bei {name}',
  'slot.centreProposes': 'Das Zentrum schlägt mir einen Termin vor',
  'slot.info': { one: '{min}-Minuten-Termine, frühestens {d} Tag nach der Bestellung (Lieferzeit der Reifen). Das Zentrum bestätigt den Termin per E-Mail.', other: '{min}-Minuten-Termine, frühestens {d} Tage nach der Bestellung (Lieferzeit der Reifen). Das Zentrum bestätigt den Termin per E-Mail.' },
  'slot.chosen': 'Gewünschter Termin: {day} um {time} — vom Zentrum zu bestätigen.',

  'home.h1': "Autoteile online zum besten Preis — Ersatzteile für alle Marken",
  'home.h1Sub': "Über 6.000 Modelle gelistet: Wählen Sie Ihr Fahrzeug oder geben Sie Ihr Kennzeichen ein, um 100 % passende Ersatzteile zu finden. Top-Marken, Lieferung in 2-5 Tagen, 14 Tage Rückgabe.",
  'home.seoTitle': "Günstige Autoteile online — Ersatzteile für alle Marken | OTOPIECES.COM",
  'home.seoDesc': "Kfz-Ersatzteile zum besten Preis bei OTOPIECES.COM: Bremsen, Filter, Motor, Reifen… Suche nach Fahrzeug oder Kennzeichen, Lieferung 2-5 Tage, 14 Tage Rückgabe.",
  'home.seoKeywords': "Autoteile, Ersatzteile, günstige Autoteile, Autoteile online, Kennzeichensuche, Bremsbeläge, Ölfilter, Reifen",
  'home.faqTitle': "Häufige Fragen zum Online-Kauf von Autoteilen",
  'home.faq1q': "Wie stelle ich sicher, dass ein Teil zu meinem Auto passt?",
  'home.faq1a': "Wählen Sie Ihr Fahrzeug (Marke, Modell, Baujahr, Motor) oder geben Sie Ihr Kennzeichen ein: Der Katalog zeigt dann nur passende Ersatzteile, mit dem Hinweis „Passt zu Ihrem Fahrzeug“ auf jeder Produktseite.",
  'home.faq2q': "Wie lange dauert die Lieferung und was kostet sie?",
  'home.faq2a': "Bestellungen werden innerhalb von 24-48 h versandt und in 2-5 Werktagen geliefert (Colissimo, Chronopost oder Mondial-Relay-Paketshop). Ab einem bestimmten Bestellwert und ab 2 Reifen ist der Versand kostenlos.",
  'home.faq3q': "Kann ich ein unpassendes Teil zurückgeben?",
  'home.faq3a': "Ja, Sie haben nach Erhalt 14 Tage Zeit, ein neues, nicht eingebautes Teil in der Originalverpackung zurückzusenden. Die Erstattung erfolgt innerhalb von 14 Tagen nach Eingang des Pakets.",
  'home.faq4q': "Gibt es eine Garantie auf die Teile?",
  'home.faq4a': "Alle bei OTOPIECES.COM verkauften Ersatzteile sind neu, stammen von führenden Herstellern (Bosch, Mann-Filter, TRW, Febi…) und unterliegen der gesetzlichen Gewährleistung von 2 Jahren.",
  'home.faq5q': "Welche Zahlungsarten akzeptieren Sie?",
  'home.faq5a': "Die Zahlung erfolgt per Karte (Visa, Mastercard, Apple Pay, Google Pay) über die sichere SumUp-Plattform. Ihre Kartendaten laufen nie über unsere Server.",
  'home.faq6q': "Bieten Sie die Montage von Teilen oder Reifen an?",
  'home.faq6a': "Ja, bei der Bestellung können Sie einen Montagetermin in einem unserer Partnerzentren buchen. Ihre Teile werden direkt dorthin geliefert und von einem Fachmann montiert.",
  'acc.bankSecureNote': "Ihre Zahlungen werden sicher über SumUp abgewickelt. Hier gespeicherte Karten dienen nur als Merkhilfe: Es werden nur die letzten 4 Ziffern gespeichert, nie die vollständige Nummer.",
  'new.menu': "Neuheiten",
  'new.menuHint': "{n} Teil(e) diese Woche hinzugefügt",
  'new.title': "Neuheiten",
  'new.h1': "Neuheiten: in den letzten {d} Tagen hinzugefügte Teile",
  'new.sub': "Die zuletzt in den Katalog aufgenommenen Ersatzteile, nach Datum sortiert. Wählen Sie Ihr Fahrzeug, um nur passende Teile zu sehen.",
  'new.days': "{d} Tage",
  'new.onlyVehicle': "Nur passend zu meinem Fahrzeug",
  'new.selectVehicle': "Wählen Sie Ihr Fahrzeug, um passende Neuheiten zu filtern",
  'new.allCats': "Alle Kategorien",
  'new.empty': "Keine Neuheiten für diese Kriterien.",
  'new.showAll': "Alle Neuheiten anzeigen",
  'new.seoTitle': "Neue Autoteile — zuletzt hinzugefügte Ersatzteile",
  'new.seoDesc': "Entdecken Sie die in den letzten {d} Tagen bei OTOPIECES.COM hinzugefügten Kfz-Ersatzteile: Bremsen, Filter, Motor… nach passendem Fahrzeug filterbar.",
  'new.badge': "Neu",
  'new.homeTitle': "Neuheiten der Woche",
  'new.homeCount': "{n} Teil(e) in den letzten 7 Tagen hinzugefügt",
  'new.homeAll': "Alle Neuheiten",
  'new.subTitleAll': "Neuheiten der Woche per E-Mail erhalten",
  'new.subTitleCat': "Neuheiten „{name}“ per E-Mail erhalten",
  'new.subHint': "Eine E-Mail montags, nur wenn es Neues gibt. Abmeldung mit einem Klick.",
  'new.subButton': "Abonnieren",
  'new.subOk': "Abonnement gespeichert",
  'new.subAlready': "Sie waren bereits abonniert — Abonnement reaktiviert",
  'new.subError': "Abonnement fehlgeschlagen",
  'new.subDone': "Erledigt! Die Neuheiten ({scope}) werden jeden Montag an {email} gesendet.",
  'new.subManage': "Meine Abonnements verwalten",
  'new.subRemoved': "Abonnement entfernt",
  'new.subsTitle': "Neuheiten per E-Mail",
  'new.subsHint': "Jeden Montag die neu in den Katalog aufgenommenen Teile Ihrer Wunschkategorien.",
  'new.subsEmpty': "Kein Abonnement. Abonnieren Sie auf der Seite",
  'new.subsSince': "Seit {d}",
  'new.subsLast': "zuletzt gesendet {d}",
  'common.loadError': "Laden fehlgeschlagen. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
  'common.retry': "Erneut versuchen",
  'product.movedToCategory': "Dieses Produkt ist nicht mehr verfügbar — hier ist die passende Kategorie.",
  'home.selectVehicle': 'Wählen Sie Ihr Fahrzeug',
  'home.brand': 'MARKE',
  'home.model': 'MODELL',
  'home.year': 'BAUJAHR',
  'home.engine': 'MOTORISIERUNG',
  'home.chooseBrand': 'Marke wählen',
  'home.chooseModel': 'Modell wählen',
  'home.chooseYear': 'Baujahr wählen',
  'home.chooseEngine': 'Motorisierung wählen',
  'home.search': 'Suchen...',
  'home.topBrands': 'Meistverkaufte Marken',
  'home.allBrands': 'Alle Marken',
  'home.noBrand': 'Keine Marke gefunden',
  'home.noModel': 'Kein Modell gefunden',
  'home.selectModel': 'Wählen Sie ein Modell',
  'home.selectYear': 'Wählen Sie ein Baujahr',
  'home.noEngine': 'Keine Motorisierung verfügbar',
  'home.selectedVehicle': 'Ausgewähltes Fahrzeug',
  'home.orPlate': 'oder per Kennzeichen suchen',
  'home.plateLabel': 'Kennen Sie Ihr Kennzeichen? Suchen Sie es in unserem Register',
  'home.searchBtn': 'Suchen',
  'home.plateRequired': 'Geben Sie Ihr Kennzeichen ein',
  'home.plateNotFound': 'Kein Fahrzeug für dieses Kennzeichen gefunden',
  'home.identified': 'Fahrzeug identifiziert:',
  'home.simulated': '(simulierte Identifizierung)',
  'home.seeParts': 'Passende Teile ansehen',
  'home.allVehicleBrands': 'Alle Fahrzeugmarken',
  'home.notFoundCar': 'Sie finden Ihr Auto nicht im Katalog?',
  'home.categoriesTitle': 'Finden Sie Ersatzteile im OTOPIECES.COM-Katalog',
  'home.moreParts': 'Weitere Ersatzteile',
  'home.accessoriesTitle': 'Auto-Essentials: Zubehör, Reinigungsprodukte und Werkzeuge',
  'home.allSubcategories': 'Alle Unterkategorien ({n})',
  'home.trust.return': '14 Tage Rückgabe',
  'home.trust.returnSub': 'Geld-zurück-Garantie',
  'home.trust.payments': 'Sichere Zahlungen',
  'home.trust.app': 'Eine praktische App',
  'home.trust.appSub': 'zum Kauf von Autoteilen',
  'home.trust.videos': 'Reparaturvideos',
  'home.trust.videosSub': 'Videoanleitungen',
  'home.bestsellers': 'Die Bestseller von OTOPIECES.COM: Ersatzteile zu günstigen Preisen kaufen',
  'home.compatibleParts': 'Passende Teile für Ihren {vehicle}',
  'home.compatibleCount': '{n} passende Teile',
  'home.seeAllCompatible': 'Alle passenden Teile ansehen',
  'home.addedToCart': 'Produkt in den Warenkorb gelegt!',
  'home.addError': 'Fehler beim Hinzufügen zum Warenkorb',
  'home.carBrands': 'Autoteile für die gefragtesten Automarken',
  'home.topModels': 'Meistgesehene Fahrzeugmodelle',
  'home.topModelsAll': 'Alle Marken',
  'home.topModelsParts': 'Passende Teile',
  'home.recentVehicles': 'Ihre zuletzt angesehenen Fahrzeuge',
  'home.recentClear': 'Löschen',
  'garage.compareTitle': 'Passende Teile vergleichen',
  'garage.compareButton': 'Vergleichen',
  'garage.compareThird': '+ 3. Fahrzeug (optional)',
  'garage.budgetTitle': 'Geschätztes jährliches Wartungsbudget',
  'garage.budgetHint': 'Schätzung anhand der passenden Teile unseres Katalogs (Verschleißteile × üblicher Wechselintervall). Medianpreis oder „Eco“ = günstigstes Teil.',
  'garage.budgetPerYear': ' / Jahr',
  'garage.dropBadge': 'Budget seit {date} um {amount}/Jahr gesunken',
  'garage.historyTitle': 'Budgetverlauf der letzten 12 Monate',
  'garage.historyMedian': 'Geschätztes Budget',
  'garage.historyEco': 'Eco-Budget',
  'garage.historyEmpty': 'Der Verlauf beginnt heute: täglich wird ein Punkt gespeichert, die Kurve entsteht in den kommenden Wochen.',
  'garage.historyChange': 'Veränderung im Zeitraum',
  'garage.historyAlert': 'Senkungs-Alarm gesendet',
  'garage.historyRange': 'Min {min} · Max {max}',
  'garage.budgetEco': 'Eco:',
  'garage.budgetEcoTotal': 'Eco-Budget:',
  'garage.budgetCoverage': '{n} von {total} Posten geschätzt',
  'garage.budgetNoParts': 'Für dieses Fahrzeug ist noch kein passendes Wartungsteil gelistet.',
  'garage.budgetPost': 'Posten',
  'garage.budgetInterval': 'Intervall',
  'garage.budgetEstimated': 'Medianpreis',
  'garage.budgetPerYearCol': 'Pro Jahr',
  'garage.budgetParts': 'passende(s) Teil(e)',
  'garage.budgetEvery': 'alle {n} Jahr(e)',
  'garage.budgetMissing': 'Nicht geschätzt (noch kein passendes Teil):',
  'garage.budgetSeeParts': 'Alle passenden Teile ansehen →',
  'garage.budgetUpcoming': 'Nächste 12 Monate:',
  'garage.logCol': 'Wartungsheft',
  'garage.logReplaced': 'Ersetzt am…',
  'garage.logNext': 'Aktuell · nächster: {d}',
  'garage.logOverdue': 'Überfällig',
  'garage.logEdit': 'ändern',
  'garage.logClear': 'Löschen',
  'garage.logSaved': 'Wartungsheft aktualisiert',
  'garage.logError': 'Speichern nicht möglich',
  'garage.logTracked': '{n} Posten erfasst',
  'garage.logHint': 'Geben Sie Datum (und km-Stand) des letzten Wechsels an: der nächste Termin ist der frühere von Datum + Intervall und km + Intervall (mit Ihrer Jahresfahrleistung umgerechnet). Der Posten verlässt bis dahin das 12-Monats-Budget; das Jahresbudget bleibt unverändert.',
  'garage.logKm': 'km beim Wechsel',
  'garage.logKmCurrent': 'aktueller km-Stand',
  'garage.logKmAt': 'bei {km}',
  'garage.logOrKm': 'oder {km}',
  'garage.logMileage': '≈ {km} heute',
  'garage.logFromOrder': 'bei OTOPIECES gekauft ({d})',
  'garage.carnetPdf': 'Wartungsheft herunterladen (PDF)',
  'garage.carnetPdfDone': 'Wartungsheft heruntergeladen',
  'garage.carnetEmail': 'Wartungsheft per E-Mail erhalten',
  'garage.carnetEmailDone': 'Wartungsheft an {email} gesendet',
  'home.seeBrands': 'Alle {n} Marken ansehen',
  'home.partsFor': 'Autoteile {brand}',
  'home.models': '{n} Modelle',
  'home.manufacturers': 'Außergewöhnliche Angebote für Autoteile der größten Hersteller',
  'home.articles': 'Alles für Ihr Auto: Ratgeber und Expertentipps',
  'home.learnMore': 'Mehr erfahren',
  'home.aboutTitle': "Kfz-Ersatzteile online: alles für Wartung und Reparatur Ihres Autos",
  'home.about1a': "OTOPIECES.COM ist Ihr Online-Shop für ",
  'home.about1b': "günstige Autoteile",
  'home.about1c': ": Bremsen (Scheiben, Beläge, Sättel), Filter (Öl-, Luft-, Innenraum-, Kraftstofffilter), Motor, Fahrwerk, Lenkung, Beleuchtung, Auspuff, Reifen und Felgen. Ob Privatfahrer, Schrauber oder Werkstatt – hier finden Sie das passende Teil für Ihr Fahrzeug zum besten Preis.",
  'home.about2a': "Jede Artikelnummer wird auf ",
  'home.about2b': "Passgenauigkeit zu Ihrem Auto",
  'home.about2c': " geprüft: Wählen Sie Marke, Modell, Baujahr und Motor oder geben Sie einfach Ihr Kennzeichen ein. Der Katalog zeigt dann nur passende Teile mit ihren OE-Nummern und Vergleichsnummern anderer Hersteller, damit Sie sicher vergleichen und auswählen können.",
  'home.about3': "Wir verkaufen ausschließlich Neuteile führender Hersteller (Bosch, Mann-Filter, TRW, Febi, Valeo…) mit 2 Jahren gesetzlicher Gewährleistung. Fragen zur Auswahl, zum Einbau oder zur Passgenauigkeit eines Teils? Unser Kundenservice aus Ersatzteil-Spezialisten antwortet schnell per Chat, E-Mail oder Telefon.",
  'home.about4a': "Bestellen Sie Ihre Autoteile mit wenigen Klicks – mit ",
  'home.about4b': "sicherer Zahlung und Lieferung in 2 bis 5 Tagen",
  'home.about4c': " in Frankreich und Europa (nach Hause oder in den Paketshop), 14 Tage Rückgaberecht und optionaler Montage in einem Partnerzentrum. OTOPIECES.COM: Ersatzteile zum fairen Preis für alle Fahrzeugmodelle.",
  'reviews.errRating': 'Wählen Sie eine Bewertung von 1 bis 5 Sternen',
  'reviews.errShort': 'Ihr Kommentar ist zu kurz (mindestens 10 Zeichen)',
  'reviews.errSend': 'Fehler beim Senden Ihrer Bewertung',
  'reviews.verifiedCount': { one: '{n} verifizierte Bewertung', other: '{n} verifizierte Bewertungen' },
  'reviews.withPhotos': { one: '{n} mit Foto', other: '{n} mit Fotos' },
  'reviews.notAllowed': 'Nur Kunden, die dieses Produkt bestellt haben, können eine Bewertung abgeben.',
  'reviews.yourReviewOn': 'Ihre Bewertung zu {name}',
  'reviews.invite': 'Danke, dass Sie sich die Zeit nehmen, Ihre Erfahrung mit diesem Teil zu teilen.',
  'reviews.submit': 'Bewertung veröffentlichen',
  'reviews.reported': 'Danke, unser Team prüft diese Bewertung.',
  'questions.voteError': 'Abstimmung nicht möglich',
  'questions.pending': 'Antwort ausstehend — nur für Sie sichtbar',
  'questions.errShort': 'Ihre Frage ist zu kurz (mindestens 10 Zeichen)',
  'questions.errName': 'Geben Sie Ihren Namen an',
  'questions.errEmail': 'Geben Sie eine gültige E-Mail an, um die Antwort zu erhalten',
  'questions.yourQuestionOn': 'Ihre Frage zu {name}',
  'questions.send': 'Frage senden',
  'tyre.summer': 'Sommerreifen', 'tyre.winter': 'Winterreifen', 'tyre.allSeason': 'Ganzjahresreifen', 'tyre.car': 'PKW', 'tyre.van': 'Transporter',
  'tyre.size': 'Größe', 'tyre.indexes': 'Last- / Geschwindigkeitsindex', 'tyre.season': 'Saison', 'tyre.vehicleType': 'Fahrzeugtyp', 'tyre.euLabel': 'EU-Label',
  'tyre.fuel': 'Kraftstoffeffizienz', 'tyre.wet': 'Nasshaftung', 'tyre.specifics': 'Besonderheiten', 'tyre.xlSpec': 'XL (verstärkt)', 'tyre.pcd': 'Lochkreis', 'tyre.offset': 'Einpresstiefe (ET)',
  'tyre.centerBore': 'Mittenbohrung', 'tyre.material': 'Material', 'tyre.steel': 'Stahl', 'tyre.aluminium': 'Aluminium', 'tyre.finish': 'Oberfläche',
  'tyre.steelWheel': 'Stahlfelge', 'tyre.aluWheel': 'Alufelge', 'tyre.snowflake': '3PMSF · Bergstraßen-zugelassen', 'tyre.xl': 'XL verstärkt',
  'tyre.euLabelView': 'Vollständiges Label & PDF', 'tyre.euLabelFull': 'EU-Reifenlabel', 'tyre.fuelFull': 'Kraftstoffeffizienz', 'tyre.noiseFull': 'Externes Rollgeräusch', 'tyre.snowGrip': 'Schneegriffigkeit (3PMSF)', 'tyre.noSnowMark': 'Keine Schnee-/Eis-Kennzeichnung', 'tyre.labelDisclaimer': 'Informatives Dokument auf Basis der Lieferantendaten; maßgeblich ist das Herstellerlabel.',
  'tyre.euLabelLine1': 'EU-', 'tyre.euLabelLine2': 'Reifenlabel', 'tyre.fuelHint': 'Energieeffizienz (A = beste)', 'tyre.wetGrip': 'Nasshaftung',
  'tyre.wetHint': 'Bremsen auf nasser Straße (A = beste)', 'tyre.noiseTitle': 'Externes Rollgeräusch', 'tyre.noiseClass': 'Geräusch · Klasse {c}',
  "acc.dashboard": "Mein OTOPIECES",
  "acc.garage": "Meine Garage",
  "acc.maintenance": "Serviceheft",
  "acc.maintenanceTitle": "Vorausschauendes Serviceheft",
  "acc.sellerListings": "Meine Gebrauchtteil-Anzeigen",
  "acc.sellerImport": "Katalog importieren",
  "acc.sellerFeeds": "Katalog-Synchronisierung",
  "acc.sellerOrders": "Meine Gebrauchtteile-Bestellungen",
  "acc.seller": "Verkäufer werden",
  "acc.pro": "Geschäftskonto",
  "acc.orders": "Meine Bestellungen",
  "acc.wishlist": "Meine Wunschliste",
  "acc.addresses": "Mein Adressbuch",
  "acc.bank": "Bankverbindung",
  "acc.wallet": "Mein Guthabenkonto",
  "acc.settings": "Einstellungen",
  "acc.compare": "Vergleich",
  "acc.logout": "Abmelden",
  "acc.proValidated": "Geprüftes Geschäftskonto",
  "acc.myAccount": "Mein Konto",
  "acc.proBannerOk": "Geschäftskonto bestätigt — {company}",
  "acc.proBannerPending": "Geschäftskonto-Antrag in Prüfung ({company})",
  "acc.proBannerRefused": "Ihr Geschäftskonto-Antrag wurde abgelehnt",
  "acc.details": "Details",
  "acc.openOrders": "{n} in Bearbeitung · {spent} ausgegeben",
  "acc.spent": "{spent} ausgegeben",
  "acc.walletCard": "Guthabenkonto",
  "acc.walletHint": "Guthaben an der Kasse nutzbar",
  "acc.wishlistCard": "Wunschliste",
  "acc.wishlistHint": "beobachtete Teile",
  "acc.vehiclesHint": "gespeicherte(s) Fahrzeug(e)",
  "acc.addressesCard": "Adressbuch",
  "acc.addressesHint": "Adresse(n)",
  "acc.cards": "{n} Karte(n)",
  "acc.ibanYes": "IBAN gespeichert",
  "acc.ibanNo": "Keine IBAN",
  "acc.lastOrder": "Letzte Bestellung",
  "acc.viewOrders": "Meine Bestellungen ansehen",
  "acc.proCta": "Sind Sie Kfz-Profi?",
  "acc.proCtaSub": "Beantragen Sie Ihr Geschäftskonto: Nettopreise, Rechnungen auf Ihre Firma, Pro-Badge.",
  "acc.personalInfo": "Persönliche Daten",
  "acc.savedAddress": "Gespeicherte Lieferadresse",
  "acc.password": "Passwort",
  "acc.prefs": "Anzeige- & Benachrichtigungseinstellungen",
  "acc.language": "Sprache",
  "acc.currency": "Währung",
  "acc.orderEmails": "Bestell-E-Mails (Bestätigung, Versand)",
  "acc.marketing": "Personalisierte Angebote und Aktionen",
  "acc.delete": "Mein Konto löschen",
  "acc.deleteInfo": "Ihre Adressen, Fahrzeuge, Listen und Karten werden gelöscht. Ihre Rechnungen bleiben über unseren Kundenservice verfügbar.",
  "acc.deleteConfirm": "Endgültig löschen",
  "acc.currentPwd": "Aktuelles Passwort *",
  "acc.newPwd": "Neues Passwort * (mind. 8 Zeichen)",
  "acc.confirmPwd": "Neues Passwort bestätigen *",
  "acc.showPwd": "Anzeigen",
  "acc.hidePwd": "Verbergen",
  "acc.pwdWord": "Passwörter",
  "acc.docLang": "Dokumentensprache (Rechnungen, E-Mails)",
  "acc.defaultShipping": "Standard-Lieferadresse",
  "acc.defaultBilling": "Standard-Rechnungsadresse",
  "acc.addressesInfo": "Ihre Adressen werden an der Kasse vorgeschlagen. Die Standard-Lieferadresse wird automatisch vorausgefüllt.",
  "acc.bankAccount": "Bankkonto (Rückerstattungen)",
  "acc.bankInfo": "Wird nur für Rückerstattungen bei Rückgabe oder Stornierung verwendet.",
  "acc.saveIban": "IBAN speichern",
  "acc.cardsInfo": "Für schnellere Bestellungen. Die vollständige Nummer wird nie gespeichert.",
  "acc.default": "Standard",
  "acc.remove": "Löschen",
  "acc.save": "Speichern",
  "acc.history": "Buchungsverlauf",
  "acc.proInfo": "Werkstätten, Karosseriebetriebe, Händler: Nettopreise, Rechnungen mit Ihrer USt-IdNr. und Pro-Badge.",
  "acc.editInfo": "Angaben bearbeiten",
  "acc.withdraw": "Antrag zurückziehen",
  "acc.companyName": "Firmenname *",
  "acc.siret": "SIRET * (14 Ziffern)",
  "acc.vatNumber": "USt-IdNr.",
  "acc.sector": "Branche *",
  "acc.companyPhone": "Firmentelefon",
  "acc.proof": "Nachweis (Kbis-Link / URL) — optional",
  "orders.loginPrompt": "Melden Sie sich an, um Ihre Bestellungen zu sehen",
  "orders.login": "Anmelden",
  "orders.empty": "Sie haben noch keine Bestellung aufgegeben",
  "orders.order": "Bestellung {n}",
  "orders.vehicle": "Fahrzeug",
  "orders.reorderVehicle": "Für mein Auto nachbestellen",
  "orders.reorderOk": "{n} Artikel wieder im Warenkorb",
  "orders.reorderPartial": "{n} Artikel im Warenkorb · {s} nicht verfügbar",
  "orders.reorderNone": "Kein Artikel dieser Bestellung ist derzeit verfügbar.",
  "orders.filterVehicle": "Nach Fahrzeug filtern",
  "orders.filterAll": "Alle",
  "orders.filterNoVehicle": "Ohne Fahrzeug",
  "orders.filterEmpty": "Keine Bestellungen für dieses Fahrzeug.",
  "orders.cancelHint": "Meinung geändert? Sie können stornieren, solange die Bestellung nicht vorbereitet wird.",
  "orders.cancel": "Bestellung stornieren",
  "orders.cancelled": "Diese Bestellung wurde storniert.",
  "orders.refunded": "Diese Bestellung wurde erstattet.",
  "orders.tracking": "Sendungsverfolgung — {carrier}",
  "orders.track": "Paket verfolgen",
  "orders.review": "Bewertung abgeben",
  "orders.walletUsed": "Verwendetes Guthaben (Guthabenkonto)",
  "orders.paid": "bezahlt {amount} €",
  "orders.fittingAt": "Montage bei {name}",
  "orders.fitTyres": { one: "{n} Reifen", other: "{n} Reifen" },
  "orders.fitRequested": "Wunschtermin: {d} — Bestätigung durch den Betrieb ausstehend.",
  "orders.fitConfirmed": "Termin bestätigt: {d}",
  "orders.fitContact": "Der Betrieb wird sich bei Ihnen melden, um den Termin zu vereinbaren{p}.",
  "orders.fitReview": "Diesen Montagebetrieb bewerten",
  "orders.fitRating": "Ihre Bewertung des Betriebs: {r}/5 — vielen Dank!",
  "appt.locked": "Termin in weniger als {h} Std.: Zum Ändern wenden Sie sich bitte an den Betrieb{p}.",
  "appt.actionFailed": "Aktion nicht möglich",
  "appt.moved": "Termin verschoben — der Betrieb muss den neuen Termin bestätigen",
  "appt.requested": "Termin angefragt — der Betrieb muss ihn bestätigen",
  "appt.confirmCancel": "Diesen Termin absagen? Die Montage bleibt geplant; der Betrieb schlägt Ihnen einen neuen Termin vor.",
  "appt.cancelled": "Termin abgesagt — der Betrieb wurde informiert",
  "appt.confirmCancelService": "Montage bei {name} endgültig stornieren?\n\nDer Montagebetrag ({a} €) wird Ihnen als Guthaben auf Ihrem Konto erstattet und eine Gutschrift (PDF) erstellt. Ihre Reifen bleiben bestellt.",
  "appt.serviceCancelled": "Montage storniert — {a} € Ihrem Guthaben gutgeschrieben",
  "appt.move": "Termin verschieben",
  "appt.pick": "Termin wählen",
  "appt.cancelSlot": "Termin absagen",
  "appt.cancelService": "Montage stornieren (Gutschrift)",
  "appt.newSlot": "Neuer Termin bei {name}",
  "appt.loadingCal": "Kalender wird geladen…",
  "appt.noCalendar": "Dieser Betrieb hat keinen Online-Kalender: Geben Sie Ihren Wunschtermin an (mindestens {h} Std. im Voraus); der Betrieb bestätigt ihn.",
  "appt.request": "Diesen Termin anfragen",
  "appt.centreConfirms": "Der Betrieb erhält eine E-Mail und bestätigt den Termin.",
  "appt.changes": { one: "{n} Terminänderung — zuletzt: {last}", other: "{n} Terminänderungen — zuletzt: {last}" },
  "appt.chCancelled": "Absage",
  "appt.chReassigned": "Wechsel zu {c}",
  "appt.chMoved": "verschoben auf {d}",
  "orders.cancelledToast": "Bestellung storniert. Die Artikel wurden wieder eingelagert.",
  "orders.cancelError": "Diese Bestellung kann nicht storniert werden",
  "status.En attente": "Ausstehend",
  "status.En cours": "In Bearbeitung",
  "status.Expédié": "Versendet",
  "status.Livré": "Geliefert",
  "status.Annulée": "Storniert",
  "status.Remboursée": "Erstattet",
  "cat.products": "Produkte",
  "cat.found": { one: "{n} Produkt gefunden", other: "{n} Produkte gefunden" },
  "cat.filterBy": "Filtern nach",
  "cat.brand": "Marke",
  "cat.noBrand": "Keine Marke",
  "cat.price": "Preis (€)",
  "cat.noneFilters": "Kein Produkt entspricht Ihren Filtern",
  "cat.noneVehicle": "Kein passendes Teil für Ihr Fahrzeug in dieser Kategorie",
  "cat.none": "Kein Produkt in dieser Kategorie gefunden",
  "cat.related": "Verwandte Suchen",
  "cat.filters": "Filter",
  "search.filterCategory": "Kategorie",
  "search.noneWithFilters": "Kein Ergebnis mit diesen Filtern.",
  "cat.sortRelevance": "Relevanz",
  "cat.sortPriceAsc": "Preis aufsteigend",
  "cat.sortPriceDesc": "Preis absteigend",
  "cat.sortRating": "Beste Bewertungen",
  "cat.sortDiscount": "Beste Rabatte",
  "cat.sortNewest": "Neuheiten",
  "cat.bestPriceTitle": "Nur Produkte anzeigen, bei denen OTOPIECES günstiger ist als alle beobachteten Mitbewerber",
  "cat.sortBy": "Sortieren nach",
  "cat.collapse": "Einklappen",
  "cat.moreSubs": "{n} weitere Unterkategorien anzeigen",
  "cat.yourVehicle": "Ihr Fahrzeug",
  "cat.onlyCompatible": "Nur passende Teile anzeigen",
  "cat.allParts": "Alle Teile anzeigen",
  "cat.change": "Ändern",
  "acc.newsletter": "Angebote und Newsletter von OTOPIECES.COM erhalten",
  "acc.changePwd": "Passwort ändern",
  "acc.deleteOpen": "Ich möchte mein Konto löschen",
  "acc.confirmYourPwd": "Passwort bestätigen",
  "acc.addrLabel": "Bezeichnung (Zuhause, Werkstatt…)",
  "acc.addrLabelPh": "Zuhause",
  "acc.myAddresses": "Meine Adressen ({n}/10)",
  "acc.addAddress": "Adresse hinzufügen",
  "acc.noAddress": "Noch keine Adresse gespeichert.",
  "acc.shipDefault": "Standard-Lieferung",
  "acc.setShipping": "Für Lieferung festlegen",
  "acc.billDefault": "Standard-Rechnung",
  "acc.setBilling": "Für Rechnung festlegen",
  "acc.holder": "Kontoinhaber *",
  "acc.savedCards": "Gespeicherte Karten ({n}/5)",
  "acc.addCard": "Karte hinzufügen",
  "acc.noCard": "Keine Karte gespeichert.",
  "acc.month": "Monat *",
  "acc.year": "Jahr *",
  "acc.txCredit": "Guthaben gutgeschrieben",
  "acc.txDebit": "Belastung",
  "acc.txOrder": "Für Bestellung verwendet",
  "acc.txRefund": "Erstattung als Guthaben",
  "acc.balance": "Verfügbares Guthaben",
  "acc.walletUsage": "Automatisch an der Kasse nutzbar (Kästchen „Mein Guthaben verwenden“).",
  "acc.noTx": "Noch keine Buchungen.",
  "acc.proPending": "Antrag in Prüfung",
  "acc.proRefused": "Antrag abgelehnt",
  "acc.resend": "Antrag erneut senden",
  "acc.requestPro": "Geschäftskonto beantragen",
  "cat.showResults": "{n} Produkt(e) anzeigen",
  "tw.searchTyres": "Reifen suchen",
  "tw.tyres": "Reifen",
  "tw.searchWheels": "Felgen suchen",
  "tw.wheels": "Felgen",
  "tw.byVehicle": "Nach Fahrzeug",
  "tw.vehicle": "Fahrzeug",
  "tw.title": "Reifen, Felgen und Zubehör",
  "tw.counts": "{t} Reifen, {w} Felgen",
  "tw.defaultTitle": "Reifen und Felgen",
  "tw.metaTitle": "Autoreifen und Felgen — Suche nach Größe oder Fahrzeug",
  "tw.metaDesc": "Finden Sie Sommer-, Winter- und Ganzjahresreifen nach Größe (205/55 R16) oder Fahrzeug (Originalgrößen) sowie Alu- oder Stahlfelgen nach Lochkreis, Einpresstiefe und Mittenbohrung.",
  "tw.intro": "Suchen Sie Ihre Reifen nach exakter Größe (Breite, Höhe, Durchmesser, Indizes), nach Fahrzeug (Originalgrößen des Herstellers) oder Ihre Felgen nach Lochkreis, Einpresstiefe und Mittenbohrung. Premium- und Budgetmarken, schnelle Lieferung, Montage im Partnerbetrieb möglich.",
  "tw.oeSubtitle": "Originalgrößen für {label}",
  "tw.accessoriesTitle": "Reifen- & Radzubehör",
  "tw.accessoriesSub": "Schrauben, Felgenschlösser, TPMS-Sensoren, Schneeketten, Wagenheber und alles rund ums Rad.",
  "tw.articles": { one: "{n} Artikel", other: "{n} Artikel" },
  "tw.comingSoon": "Bald verfügbar",
  "tw.popularSizes": "Häufigste Größen",
  "tw.allSeasons": "Reifen für jede Saison",
  "tw.brands": "Reifen- und Felgenmarken",
  "tw.guideTitle": "{k}: der OTOPIECES-Ratgeber",
  "tw.about": "Über: {n}",
  "tw.faqTitle": "Häufige Fragen: {n}",
  "tw.summer": "Sommer",
  "tw.winter": "Winter",
  "tw.fourSeasons": "Ganzjahr",
  "tw.vt.voiture": "Pkw",
  "tw.vt.suv": "4x4 / SUV",
  "tw.vt.utilitaire": "Transporter",
  "tw.vt.4x4": "4x4",
  "tw.quickSearch": "Schnellsuche nach Größe",
  "tw.quickSearchEx": "— z. B. 205 / 55 R16 91V",
  "tw.howToRead": "Wie lese ich meinen Reifen?",
  "tw.width": "Breite",
  "tw.height": "Höhe",
  "tw.diameter": "Durchmesser",
  "tw.loadIndex": "Tragfähigkeitsindex",
  "tw.speedIndex": "Geschwindigkeitsindex",
  "tw.widthPh": "Breite (z. B. 205)",
  "tw.heightPh": "Höhe (z. B. 55)",
  "tw.diameterPh": "Durchmesser (z. B. R16)",
  "tw.season": "Saison",
  "tw.advanced": "Nach Parametern auswählen",
  "tw.brand": "Marke",
  "tw.model": "Modell",
  "tw.allBrands": "Alle Marken",
  "tw.modelPh": "z. B. Primacy, CrossClimate…",
  "tw.homologation": "Freigabe (z. B. MO, *, AO)",
  "tw.optional": "Optional",
  "tw.priceMin": "Mindestpreis (€)",
  "tw.priceMax": "Höchstpreis (€)",
  "tw.priceMinShort": "Preis min. (€)",
  "tw.priceMaxShort": "Preis max. (€)",
  "tw.runflat": "Notlauf (RunFlat)",
  "tw.runflatHint": "Ermöglicht ~80 km bei 80 km/h nach einer Panne",
  "tw.xl": "Verstärkt (XL)",
  "tw.xlHint": "Erhöhte Tragfähigkeit",
  "tw.ms": "Matsch / Schnee (M+S)",
  "tw.snowflake": "Schneegriff (3PMSF)",
  "tw.studded": "Spikes",
  "tw.reset": "Filter zurücksetzen",
  "tw.tyresInCatalog": "{n} Reifen im Katalog",
  "tw.wheelsInCatalog": "{n} Felgen im Katalog",
  "tw.wheelSpecs": "Felgendaten",
  "tw.wheelSpecsEx": "— z. B. 7J x 17 — 5x112 — ET45 — Mittenbohrung 66,6 mm",
  "tw.widthJ": "Breite (J)",
  "tw.widthJPh": "Breite (z. B. 7J)",
  "tw.diameterInPh": "Durchmesser (z. B. 17\")",
  "tw.holes": "Lochzahl",
  "tw.holesPh": "Löcher (z. B. 5)",
  "tw.pcd": "Lochkreis (PCD)",
  "tw.pcdPh": "PCD (z. B. 112)",
  "tw.et": "Einpresstiefe (ET)",
  "tw.etPh": "ET (z. B. ET45)",
  "tw.centerBore": "Mittenbohrung",
  "tw.centerBorePh": "Mittenbohrung (z. B. 66,6)",
  "tw.material": "Material",
  "tw.type": "Typ",
  "tw.color": "Farbe / Finish",
  "tw.allF": "Alle",
  "tw.allM": "Alle",
  "tw.wheelModelPh": "z. B. TZ, Ultraleggera…",
  "tw.mat.aluminium": "Aluminium",
  "tw.mat.acier": "Stahl",
  "tw.type.alu": "Alufelge",
  "tw.type.tole": "Stahlfelge",
  "tw.type.ete": "Sommerfelge",
  "tw.type.hiver": "Winterfelge",
  "tw.outOfStock": "Nicht auf Lager",
  "tw.leadDays": "In {n} Tagen",
  "tw.inStock": "Auf Lager · Versand innerhalb 24 h",
  "tw.pcdShort": "Lochkreis",
  "tw.offset": "Einpresstiefe",
  "tw.bore": "Mittenbohrung",
  "tw.finish": "Finish",
  "tw.perUnit": "pro Stück · {p} € für 4",
  "tw.viewProduct": "Produkt ansehen",
  "tw.tyresFound": { one: "{n} Reifen gefunden", other: "{n} Reifen gefunden" },
  "tw.wheelsFound": { one: "{n} Felge gefunden", other: "{n} Felgen gefunden" },
  "tw.sortPriceAsc": "Preis aufsteigend",
  "tw.sortPriceDesc": "Preis absteigend",
  "tw.sortRating": "Beste Bewertungen",
  "tw.sortBrand": "Marke A→Z",
  "tw.noResults": "Keine Ergebnisse für diese Kriterien",
  "tw.noResultsHint": "Erweitern Sie die Suche: entfernen Sie einen Index oder eine Option.",
  "tw.eu.title": "EU-Label",
  "tw.eu.fuel": "Kraftstoff",
  "tw.eu.wet": "Nasshaftung",
  "tw.eu.noise": "Geräusch",
  "tw.eu.onlyA": "Nur A",
  "tw.eu.aTo": "A bis {g}",
  "tw.eu.noiseA": "≤ 68 dB (Klasse A)",
  "tw.eu.noiseB": "≤ 71 dB (Klasse B)",
  "tw.eu.noise75": "≤ 75 dB",
  "tw.eu.snowflake": "3PMSF (Alpine-Symbol)",
  "tw.vs.pickAtLeast": "Wählen Sie mindestens Marke und Modell",
  "tw.vs.notFound": "Fahrzeug nicht gefunden",
  "tw.vs.select": "Wählen Sie Ihr Fahrzeug",
  "tw.vs.selectSub": "— wir zeigen die ab Werk montierten Reifen- und Felgengrößen",
  "tw.vs.showOE": "Originalgrößen anzeigen",
  "tw.vs.reset": "Zurücksetzen",
  "tw.vs.searching": "Herstellerdaten für {v} werden gesucht… (beim ersten Mal bis zu 30 s)",
  "tw.vf.tyresAvail": { one: "{n} Reifen verfügbar", other: "{n} Reifen verfügbar" },
  "tw.vf.wheelsAvail": { one: "{n} Felge verfügbar", other: "{n} Felgen verfügbar" },
  "tw.vf.none": "Noch keine Artikel",
  "tw.vf.notFound": "Keine Originalgrößen hinterlegt für {v}",
  "tw.vf.notFoundHint": "Lesen Sie die Größe auf der Reifenflanke ab (z. B. 205/55 R16 91V) und nutzen Sie die Suche nach Größe.",
  "tw.vf.switch": "Nach Größe suchen →",
  "tw.vf.oeFor": "Originalgrößen des Herstellers für",
  "tw.vf.aiNotice": "Größen wurden automatisch aus Herstellerdaten ermittelt und werden noch von unserem Team geprüft. Bestätigen Sie vor der Bestellung die Größe auf der Flanke Ihres aktuellen Reifens.",
  "tw.vf.oeTyres": "Originalreifen",
  "tw.vf.oeWheels": "Originalfelgen",
  "tw.vf.thread": "Gewinde",
  "tw.vf.diameters": "Durchmesser",
  "tw.vf.seeTyres": "Passende Reifen ansehen",
  "tw.vf.seeWheels": "Passende Felgen ansehen",
  "tw.vf.in": "in {s}",
  "tw.vc.year": "Baujahr",
  "tw.vc.engine": "Motorisierung",
  "tw.vc.pickBrand": "Marke wählen",
  "tw.vc.pickModel": "Modell wählen",
  "tw.vc.selBrand": "Wählen Sie eine Marke",
  "tw.vc.pickYear": "Baujahr wählen",
  "tw.vc.selModel": "Wählen Sie ein Modell",
  "tw.vc.allEngines": "Alle Motorisierungen",
  "tw.vc.selYear": "Wählen Sie das Baujahr",
  "tw.vc.hp": "PS",
  "tw.sg.title": "Wie liest man die Reifengröße?",
  "tw.sg.sub": "Alles steht auf der Reifenflanke. Fahren oder tippen Sie über jedes Element des Beispiels",
  "tw.sg.width": "Breite",
  "tw.sg.widthDesc": "Reifenbreite in Millimetern, von Flanke zu Flanke gemessen (hier 205 mm).",
  "tw.sg.height": "Höhe (Querschnitt)",
  "tw.sg.heightDesc": "Flankenhöhe in % der Breite: 55 % von 205 mm ≈ 113 mm. Je kleiner die Zahl, desto flacher der Reifen.",
  "tw.sg.radial": "Bauart",
  "tw.sg.radialDesc": "R = Radialbauweise, Standard bei allen modernen Autos.",
  "tw.sg.diameter": "Felgendurchmesser",
  "tw.sg.diameterDesc": "Innendurchmesser des Reifens = Durchmesser Ihrer Felge, in Zoll (16\" ≈ 40,6 cm).",
  "tw.sg.load": "Tragfähigkeitsindex",
  "tw.sg.loadDesc": "Maximale Last pro Reifen: 91 = 615 kg. Niemals unter den vom Hersteller vorgegebenen Index gehen.",
  "tw.sg.speed": "Geschwindigkeitsindex",
  "tw.sg.speedDesc": "Zulässige Höchstgeschwindigkeit: T 190 km/h · H 210 · V 240 · W 270 · Y 300. Ein Winterreifen darf einen niedrigeren Index haben (in Frankreich mind. H, wenn ≥ Höchstgeschwindigkeit − 1 Kategorie).",
  "tw.sg.where": "Wo finde ich die Angabe?",
  "tw.sg.whereText": "Auf der Flanke des aktuellen Reifens, auf dem Aufkleber im Türrahmen der Fahrertür, in der Tankklappe oder im Serviceheft. Sie können auch den Reiter",
  "tw.sg.whereEnd": "nutzen, um die Originalgrößen zu finden.",
  "auth.loginTitle": "Anmelden",
  "auth.loginSub": "Zugang zu Ihrem OTOPIECES.COM-Konto",
  "auth.sessionExpired": "Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.",
  "auth.email": "E-Mail",
  "auth.password": "Passwort",
  "auth.emailPh": "ihre@email.de",
  "auth.passwordPh": "Ihr Passwort",
  "auth.remember": "Angemeldet bleiben",
  "auth.rememberDays": "(30 Tage)",
  "auth.forgot": "Passwort vergessen?",
  "auth.loggingIn": "Anmeldung...",
  "auth.login": "Anmelden",
  "auth.noAccount": "Noch kein Konto?",
  "auth.createAccount": "Konto erstellen",
  "auth.emailRequired": "E-Mail erforderlich",
  "auth.passwordRequired": "Passwort erforderlich",
  "auth.badCredentials": "E-Mail oder Passwort falsch",
  "auth.registerSub": "Erstellen Sie Ihr Konto, um Bestellungen zu verfolgen und Fahrzeuge zu speichern",
  "auth.firstName": "Vorname",
  "auth.lastName": "Nachname",
  "auth.firstNamePh": "Max",
  "auth.lastNamePh": "Mustermann",
  "auth.emailPh2": "max.mustermann@email.de",
  "auth.phone": "Telefon (optional)",
  "auth.phonePh": "0151 23456789",
  "auth.min8": "Mindestens 8 Zeichen",
  "auth.confirmPassword": "Passwort bestätigen",
  "auth.repeatPh": "Passwort wiederholen",
  "auth.acceptPrefix": "Ich akzeptiere die",
  "auth.terms": "AGB",
  "auth.and": "und die",
  "auth.privacy": "Datenschutzerklärung",
  "auth.newsletter": "Ich möchte Angebote und Aktionen per E-Mail erhalten",
  "auth.sessionHint": "Sie bleiben auf diesem Gerät 30 Tage angemeldet.",
  "auth.creating": "Konto wird erstellt...",
  "auth.createMine": "Mein Konto erstellen",
  "auth.haveAccount": "Bereits ein Konto?",
  "auth.firstNameRequired": "Vorname erforderlich",
  "auth.lastNameRequired": "Nachname erforderlich",
  "auth.emailInvalid": "Ungültige E-Mail",
  "auth.passwordsMismatch": "Die Passwörter stimmen nicht überein",
  "auth.acceptRequired": "Sie müssen die Bedingungen akzeptieren",
  "auth.registerError": "Fehler bei der Registrierung",
  "auth.forgotTitle": "Passwort vergessen",
  "auth.forgotMeta": "Setzen Sie das Passwort Ihres OTOPIECES.COM-Kontos zurück.",
  "auth.forgotIntro": "Geben Sie Ihre E-Mail-Adresse ein: Wir senden Ihnen einen Link, um ein neues Passwort zu wählen.",
  "auth.checkInbox": "Prüfen Sie Ihren Posteingang",
  "auth.sentBefore": "Falls ein Konto mit der Adresse",
  "auth.sentAfter": " existiert, wurde gerade eine E-Mail mit einem Link zum Zurücksetzen (1 Stunde gültig) gesendet.",
  "auth.spam": "Prüfen Sie auch Ihren Spam-Ordner.",
  "auth.backLogin": "Zurück zur Anmeldung",
  "auth.emailAddress": "E-Mail-Adresse",
  "auth.sendLink": "Link zum Zurücksetzen senden",
  "auth.emailAddressInvalid": "Ungültige E-Mail-Adresse",
  "auth.genericError": "Ein Fehler ist aufgetreten, versuchen Sie es gleich noch einmal",
  "auth.resetTitle": "Neues Passwort",
  "auth.resetMeta": "Wählen Sie ein neues Passwort für Ihr OTOPIECES.COM-Konto.",
  "auth.account": "Konto:",
  "auth.linkIncomplete": "Unvollständiger Link: Öffnen Sie den per E-Mail erhaltenen Link.",
  "auth.linkInvalid": "Ungültiger oder abgelaufener Link",
  "auth.requestNew": "Neuen Link anfordern",
  "auth.changed": "Passwort geändert!",
  "auth.redirecting": "Sie sind jetzt angemeldet. Weiterleitung…",
  "auth.newPassword": "Neues Passwort",
  "auth.min8Ph": "Mindestens 8 Zeichen",
  "auth.saveNew": "Neues Passwort speichern",
  "auth.min8Long": "Das Passwort muss mindestens 8 Zeichen enthalten",
  "auth.cannotChange": "Passwort konnte nicht geändert werden",
  "auth.tooMany": "Zu viele Anfragen. Bitte versuchen Sie es in 15 Minuten erneut.",
  "auth.linkInvalidDetail": "Dieser Link ist ungültig oder abgelaufen. Bitte fordern Sie einen neuen Link an.",
  "common.loading": "Wird geladen…",
  "search.parts": "Teile {b}",
  "search.metaQuery": "Suche « {q} »",
  "search.metaDefault": "Teilesuche",
  "search.metaDesc": "Suchergebnisse für {q} auf OTOPIECES.COM: {n} Produkt(e) gefunden.",
  "search.brandPage": "Markenseite ansehen",
  "search.resultsFor": "Ergebnisse für « {q} »",
  "search.title": "Suche",
  "search.noMatch": "Kein Produkt entspricht « {q} »",
  "search.hint": "Geben Sie ein Stichwort, eine Marke oder eine Referenz ein",
  "search.showUnfiltered": "Die {n} ungefilterten Ergebnisse nach Fahrzeug anzeigen",
  "brands.metaTitle": "Alle Kfz-Teilemarken von A bis Z",
  "brands.metaDesc": "Entdecken Sie die {n} auf OTOPIECES.COM verfügbaren Ersatzteilmarken{list}. Originalqualität und 2 Jahre Garantie.",
  "brands.all": "Alle Marken",
  "brands.countAZ": { one: "{n} Ersatzteilmarke, von A bis Z sortiert", other: "{n} Ersatzteilmarken, von A bis Z sortiert" },
  "brands.searchPh": "Eine Marke suchen…",
  "brands.noMatch": "Keine Marke entspricht « {q} ».",
  "search.nearTitle": "Meinten Sie… ähnliche Referenzen",
  "search.nearVia": "über Ref.",
  "partRequest.cta": "Dieses Teil anfragen",
  "partRequest.ctaHint": "Wir beschaffen das Teil bei unseren Lieferanten und melden uns innerhalb von 24 Werkstunden per E-Mail.",
  "partRequest.title": "Dieses Teil anfragen",
  "partRequest.intro": "Hinterlassen Sie Ihre Daten: unser Team prüft Verfügbarkeit und Preis und antwortet per E-Mail.",
  "partRequest.msgSearch": "Gesuchtes Teil",
  "partRequest.msgVehicle": "Fahrzeug",
  "partRequest.msgDetails": "Details",
  "partRequest.detailsPh": "Hilfreiche Angaben: OE-Nummer, Seite (links/rechts), Baujahr, Foto des Teils…",
  "partRequest.submit": "Anfrage senden",
  "partRequest.sent": "Anfrage gesendet!",
  "partRequest.sentDesc": "Eine Empfangsbestätigung wurde Ihnen per E-Mail zugeschickt; wir melden uns in Kürze.",
  "cat.topRated": "4 ★ und mehr",
  "cat.topRatedTitle": "Nur Teile mit mindestens 4/5 Kundenbewertung anzeigen",
  "brands.sortBy": "Sortieren:",
  "brands.sortAz": "A → Z",
  "brands.sortTrust": "Vertrauensscore",
  "brands.noReviews": "Noch keine Bewertungen",
  "brands.trustHint": { one: "{n} von unseren Kunden bewertete Marke — beste zuerst, dann Marken ohne Bewertungen alphabetisch.", other: "{n} von unseren Kunden bewertete Marken — beste zuerst, dann Marken ohne Bewertungen alphabetisch." },
  "brand.notFound": "Marke nicht gefunden",
  "brand.metaCat": "{c} {b} — Kfz-Teile",
  "brand.metaTitle": "Teile {b} — Katalog und Preise",
  "brand.metaDesc": "Alle Ersatzteile {b}: {n} Produkt(e) in {cats}. Originalqualität, 2 Jahre Garantie, schnelle Lieferung in Frankreich.",
  "brand.noProducts": "Kein Produkt « {b} » in unserem Katalog.",
  "brand.eyebrow": "Teilemarke",
  "brand.products": { one: "{n} Produkt", other: "{n} Produkte" },
  "brand.categories": { one: "{n} Kategorie", other: "{n} Kategorien" },
  "cmp.title": "Produktvergleich",
  "cmp.addFailed": "Hinzufügen nicht möglich",
  "cmp.price": "Preis inkl. MwSt.",
  "cmp.oldPrice": "Durchgestrichener Preis",
  "cmp.discount": "Rabatt",
  "cmp.rating": "Kundenbewertung",
  "cmp.availability": "Verfügbarkeit",
  "cmp.inStock": "Auf Lager",
  "cmp.outOfStock": "Nicht vorrätig",
  "cmp.ref": "Referenz",
  "cmp.subcategory": "Unterkategorie",
  "cmp.soldBy": "Verkauft von",
  "cmp.pack": "Set",
  "cmp.packs": "Verpackungen",
  "cmp.warranty": "Garantie",
  "cmp.twoYears": "2 Jahre",
  "cmp.compat": "Kompatibilität",
  "cmp.universal": "Universell",
  "cmp.intro": "{n}/{max} Produkte · fügen Sie Teile derselben Kategorie über die Produktkarten hinzu (Waage-Symbol).",
  "cmp.clear": "Vergleich löschen",
  "cmp.empty": "Ihr Vergleich ist leer",
  "cmp.emptyHint": "Durchsuchen Sie den Katalog und klicken Sie auf das Waage-Symbol, um bis zu {max} Teile zu vergleichen.",
  "cmp.browse": "Teile anzeigen",
  "cmp.remove": "Entfernen",
  "nf.metaTitle": "Seite nicht gefunden (404)",
  "nf.title": "Dieses Teil ist nicht im Katalog…",
  "nf.text": "Die angeforderte Seite wurde verschoben, gelöscht oder hat nie existiert. Keine Sorge: Der richtige Weg steht direkt unten.",
  "nf.searchPh": "Nach einem Teil, einer Referenz, einer Marke suchen…",
  "nf.search": "Suchen",
  "nf.topCategories": "Am häufigsten gesuchte Kategorien",
  "wl.guestBefore": "Ihre Liste ist auf diesem Gerät gespeichert.",
  "wl.guestLogin": "Anmelden",
  "wl.guestAfter": "um sie überall wiederzufinden und zu behalten.",
  "chat.tooShort": "Beschreiben Sie Ihre Anfrage in wenigen Worten (mindestens 10 Zeichen).",
  "chat.failed": "Senden nicht möglich, bitte erneut versuchen.",
  "chat.open": "Kundenservice kontaktieren",
  "chat.greeting": "Guten Tag! Stellen Sie Ihre Frage, ein Berater antwortet Ihnen per E-Mail.",
  "chat.another": "Eine weitere Nachricht senden",
  "chat.sent": "Nachricht gesendet!",
  "chat.replyTime": "Antwort per E-Mail innerhalb von 24 Arbeitsstunden",
  "chat.reference": "Referenz",
  "chat.messagePh": "Geben Sie Ihre Nachricht ein...",
  "chat.emailPh": "Ihre E-Mail",
  "chat.namePh": "Ihr Name",
  "contact.sent": "Nachricht gesendet",
  "contact.failed": "Senden nicht möglich",
  "contact.address": "Adresse",
  "contact.phoneWa": "Telefon / WhatsApp",
  "contact.hours": "Öffnungszeiten",
  "contact.metaDesc": "Kontaktieren Sie den OTOPIECES.COM-Kundenservice: Telefon, E-Mail, Formular. Antwort innerhalb von 24 Arbeitsstunden.",
  "contact.heading": "Eine Frage? Wir antworten.",
  "contact.intro": "Teilekompatibilität, Bestellverfolgung, Rücksendung oder Rechnung: Unser Team aus Auto-Enthusiasten hilft Ihnen gern weiter.",
  "contact.tracking": "Sendungsverfolgung",
  "contact.returns": "Rücksendungen",
  "contact.writeUs": "Schreiben Sie uns",
  "contact.ackSent": "Eine Empfangsbestätigung wurde Ihnen per E-Mail gesendet; wir antworten Ihnen innerhalb von 24 Werktunden.",
  "contact.message": "Nachricht",
  "contact.received": "Nachricht erfolgreich erhalten!",
  "contact.fullName": "Vollständiger Name",
  "contact.newMessage": "Neue Nachricht",
  "contact.orderNo": "Bestellnummer (optional)",
  "contact.subject": "Betreff",
  "contact.phone": "Telefon",
  "contact.privacyNote": "Ihre Daten werden ausschließlich zur Bearbeitung Ihrer Anfrage verwendet.",
  "contact.messagePh": "Beschreiben Sie Ihre Anfrage (Fahrzeug, Teilenummer, aufgetretenes Problem…)",
  "contact.details": "Unsere Kontaktdaten",
  "contact.send": "Senden",
  "chat.page": "Seite:",
  "chat.send": "Senden",
  "orders.invoicePdf": "PDF-Rechnung",
  "cat.all": "Alle",
  "cat.filterSubs": "{n} Unterkategorien filtern…",
  "cat.noSubMatch": "Keine Unterkategorie entspricht „{q}“",
  "cat.otherSubs": "Weitere Unterkategorien {name}",
  "cat.subsubs": "Unterkategorien von {name}",
  "xsell.badge": "Sinnvolle Ergänzung",
  "xsell.compatible": "Passt zu Ihrem Fahrzeug",
  "xsell.addedTitle": "In den Warenkorb gelegt",
  "xsell.completeTitle": "Vervollständigen Sie Ihren Einkauf",
  "xsell.completeHint": "Das Nötige für die Reparatur — Sie entscheiden.",
  "xsell.continue": "Weiter einkaufen",
  "xsell.cartTitle": "Das Nötige für Ihre Wartung",
  "xsell.cartHint": "Nützliche Ergänzungen zu den Teilen in Ihrem Warenkorb.",
  "xsell.productTitle": "Ergänzende Produkte",
  "xsell.productHint": "Oft für diese Arbeit erforderlich.",
  "cat.quickFilters": "Schnellfilter",
  "cat.quickFiltersHint": "Wählen Sie eine Unterkategorie von {name} und eine Marke: das richtige Teil in zwei Klicks.",
  "cat.nProducts": { one: "{n} Produkt", other: "{n} Produkte" },
  "banner.discover": "Entdecken",
  "banner.prev": "Vorheriges Banner",
  "banner.next": "Nächstes Banner",
  "banner.n": "Banner {n}",
  "about.title": "Wer sind wir",
  "about.eyebrow": "Über uns",
  "about.heading": "{name}, das Autoersatzteil ohne Aufwand",
  "about.intro": "Aus der Frustration heraus entstanden, nie die richtige Referenz zu finden, vereint unser Shop Herstellerkatalog, Expertenrat und Expresslieferung.",
  "about.description": "{name}: der französische Spezialist für Autoersatzteile online. Unsere Geschichte, unsere Werte, unser Team.",
  "about.kpiRefs": "Referenzen auf Lager",
  "about.kpiMakers": "Originalausrüster",
  "about.kpiBrands": "Fahrzeugmarken",
  "about.kpiShip": "Versandzeit",
  "about.kpiShipValue": "24 Std.",
  "about.storyTitle": "Unsere Geschichte",
  "about.story1": "Alles beginnt in einer freien Werkstatt: zu viel Zeit auf der Suche nach einer Referenz, zu viele Kompatibilitätsfehler, zu lange Lieferzeiten. Wir beschlossen, das Werkzeug zu bauen, das wir uns gewünscht hätten: einen exakten Katalog nach Motorisierung, Ausrüsterpreise und eine Lieferung, die hält, was sie verspricht.",
  "about.story2": "Heute bestellen Privatkunden und Profis bei {name} Brems-, Filter-, Steuerketten-, Fahrwerks- oder Karosserieteile der größten Marken — TRW, Bosch, Brembo, Valeo, Mann-Filter, LuK… — mit der Garantie des richtigen Teils zum richtigen Preis.",
  "about.promiseLabel": "Unser Versprechen",
  "about.promise": "„Das richtige Teil, schnell geliefert, zum fairen Preis — und bei Bedarf ein Mensch am Telefon.“",
  "about.valuesTitle": "Unsere Werte",
  "about.v1Title": "Das passende Teil, auf Anhieb",
  "about.v1Text": "Kompatibilität geprüft anhand exakter Motorisierung und Kennzeichensuche: null Referenzfehler.",
  "about.v2Title": "Der faire Preis",
  "about.v2Text": "Direktkauf bei Erstausrüstern, Staffelpreise und transparente Geschäftskonditionen.",
  "about.v3Title": "Schnell geliefert, sicher geliefert",
  "about.v3Text": "Versand innerhalb von 24 Std., Partner-Transportdienstleister und Echtzeit-Tracking bis vor Ihre Tür.",
  "about.v4Title": "Verantwortungsvoll",
  "about.v4Text": "Recycelte Verpackungen, Aufarbeitung von Rücksendungen und zertifizierte Partner.",
  "about.teamTitle": "Das Team",
  "about.t1Name": "Kundenservice",
  "about.t1Role": "Antwort innerhalb von 24 Werktagsstunden",
  "about.t2Name": "Technische Experten",
  "about.t2Role": "Mechaniker & Karosseriebauer",
  "about.t3Name": "Logistik",
  "about.t3Role": "Vorbereitung & Versand",
  "about.t4Name": "Einkauf",
  "about.t4Role": "Auswahl der Erstausrüster",
  "about.joinTitle": "Möchten Sie zu uns kommen oder mit uns zusammenarbeiten?",
  "about.joinText": "Karriere, Partnerschaften, Presse: sprechen wir darüber.",
  "about.careers": "Karriere",
  "about.contact": "Kontaktieren Sie uns",
  "ret.title": "Garantie & Rücksendungen",
  "ret.description": "Rückgabe innerhalb von 14 Tagen, 2 Jahre Garantie auf alle OTOPIECES.COM-Teile. Rücksendeverfahren in 4 Schritten.",
  "ret.heading": "Zufrieden oder Geld zurück, 2 Jahre Garantie",
  "ret.intro": "Ein Referenzfehler, ein Teil passt nicht? Die Rücksendung ist einfach und die Erstattung schnell.",
  "ret.k1": "14 Tage",
  "ret.k1Text": "zum Umdenken",
  "ret.k2": "2 Jahre",
  "ret.k2Text": "Herstellergarantie",
  "ret.k3": "5 Tage",
  "ret.k3Text": "für die Erstattung",
  "ret.stepsTitle": "Ein Teil in 4 Schritten zurücksenden",
  "ret.s1Title": "Rücksendung anmelden",
  "ret.s1Text": "Unter « Meine Bestellungen » stornieren Sie oder kontaktieren Sie uns unter Angabe der Bestellnummer und des betreffenden Teils.",
  "ret.s2Title": "Teil verpacken",
  "ret.s2Text": "Unmontiertes Teil, in der Originalverpackung mit der Rechnung. Wir senden Ihnen das Rücksendeetikett.",
  "ret.s3Title": "Paket abgeben",
  "ret.s3Text": "In der Postfiliale oder Paketstation innerhalb von 14 Tagen. Die Sendungsverfolgung informiert uns über den Eingang.",
  "ret.s4Title": "Erstattung",
  "ret.s4Text": "Innerhalb von 5 Tagen nach Prüfung: auf Ihr Zahlungsmittel oder als sofortige Gutschrift auf Ihr Guthabenkonto.",
  "ret.coveredTitle": "Von der Garantie abgedeckt",
  "ret.covered1": "Herstellungs- oder Materialfehler",
  "ret.covered2": "Teil entspricht nicht der bestellten Referenz",
  "ret.covered3": "Beschädigung oder fehlendes Teil bei der Lieferung",
  "ret.covered4": "Vorzeitiger Ausfall bei normaler Nutzung",
  "ret.notCoveredTitle": "Nicht abgedeckt",
  "ret.notCovered1": "Montiertes, genutztes oder verändertes Teil",
  "ret.notCovered2": "Normale Abnutzung (Bremsbeläge, Scheiben, Filter…)",
  "ret.notCovered3": "Einbau nicht gemäß Herstellervorgaben",
  "ret.notCovered4": "Rücksendung außerhalb der 14-Tage-Frist oder ohne Originalverpackung",
  "ret.ctaTitle": "Bereit, ein Teil zurückzusenden?",
  "ret.ctaText": "Gehen Sie in Ihre Bestellungen, um eine Rücksendung zu stornieren oder zu melden, oder kontaktieren Sie unseren Kundenservice.",
  "ret.ctaOrders": "Rücksendung anfragen",
  "ret.ctaContact": "Kontaktieren Sie uns",
  "sm.title": "Sitemap",
  "sm.description": "Alle Seiten von OTOPIECES.COM: Teilekategorien, Marken, Kundenbereich, Informationen.",
  "sm.eyebrow": "Navigation",
  "sm.intro": "Finden Sie auf einen Blick alle Bereiche des Shops.",
  "sm.shop": "Shop",
  "sm.account": "Mein Konto",
  "sm.help": "Hilfe",
  "sm.home": "Startseite",
  "sm.allParts": "Alle Teile",
  "sm.brandsAZ": "Marken von A bis Z",
  "sm.guides": "Ratgeber & Tipps",
  "sm.compare": "Vergleichsportal",
  "sm.cart": "Warenkorb",
  "sm.myOto": "Mein OTOPIECES",
  "sm.garage": "Meine Garage",
  "sm.pro": "Geschäftskonto",
  "sm.orders": "Meine Bestellungen",
  "sm.wishlist": "Meine Wunschliste",
  "sm.addresses": "Adressbuch",
  "sm.bank": "Bankverbindung",
  "sm.wallet": "Einzahlungskonto",
  "sm.settings": "Einstellungen",
  "sm.login": "Anmeldung",
  "sm.register": "Registrierung",
  "sm.contact": "Kontakt",
  "sm.shipping": "Lieferung & Sendungsverfolgung",
  "sm.returns": "Garantie & Rücksendungen",
  "sm.about": "Über uns",
  "sm.sitemap": "Sitemap",
  "sm.categories": "Ersatzteilkategorien",
  "sm.vehicleBrands": "Fahrzeugmarken",
  "sm.makers": "Hersteller",
  "sm.pages": "Informationen & rechtliche Seiten",
  "garage.title": "Meine Fahrzeuge",
  "garage.add": "Fahrzeug hinzufügen",
  "garage.intro": "Speichern Sie Ihre Fahrzeuge, um kompatible Teile mit einem Klick zu finden. Wenn Sie Ihr Kennzeichen hinzufügen, wird es nach Bestätigung durch unser Team bei der Kennzeichensuche erkannt.",
  "garage.selectRequired": "Marke, Modell und Baujahr auswählen",
  "garage.addedPlate": "Fahrzeug hinzugefügt — sein Kennzeichen wird nach Bestätigung durch unser Team bei der Kennzeichensuche erkannt",
  "garage.added": "Fahrzeug hinzugefügt",
  "garage.addError": "Fehler beim Hinzufügen des Fahrzeugs",
  "garage.confirmDelete": "{name} löschen?",
  "garage.deleted": "Fahrzeug gelöscht",
  "garage.newVehicle": "Neues Fahrzeug",
  "garage.brand": "Marke *",
  "garage.model": "Modell *",
  "garage.year": "Baujahr *",
  "garage.engine": "Motorisierung",
  "garage.hp": "PS",
  "garage.platePh": "Kennzeichen (optional) — AA-123-BB",
  "garage.labelPh": "Spitzname (optional) — z. B. Auto von Marie",
  "garage.cancel": "Abbrechen",
  "garage.save": "Speichern",
  "garage.empty": "Derzeit ist kein Fahrzeug gespeichert.",
  "garage.plateValidated": "Kennzeichen bestätigt",
  "garage.plateRefused": "Kennzeichen abgelehnt",
  "garage.platePending": "Kennzeichen wartet auf Bestätigung",
  "garage.useSelected": "Fahrzeug ausgewählt · Teile anzeigen",
  "garage.use": "Dieses Fahrzeug verwenden",
  "garage.delete": "Löschen",
  "mb.mileage": "Aktueller Kilometerstand",
  "mb.mileagePh": "z. B. 85000",
  "mb.yearly": "km / Jahr (Schätzung)",
  "mb.save": "Speichern",
  "mb.overdueKm": "um {n} km überschritten",
  "mb.inKm": "in {n} km",
  "mb.overdueDays": "um {n} Tage überschritten",
  "mb.inDays": "in {n} Tagen",
  "mb.lastPurchase": "letzter Kauf {date}",
  "mb.seeParts": "Teile anzeigen",
  "mb.noVehicle1": "Fügen Sie ein Fahrzeug in",
  "mb.noVehicleLink": "Meine Garage",
  "mb.noVehicle2": "zur Aktivierung Ihres vorausschauenden Wartungshefts.",
  "mb.estimated": "geschätzt heute",
  "mb.enterMileage": "Geben Sie Ihren Kilometerstand ein, um Ihre Wartungstermine zu erhalten (Steuerkette/-riemen, Bremsen, Filter…).",
  "mb.alertsTitle": "Gesendete Benachrichtigungen",
  "mb.see": "Ansehen",
  "mb.diagTitle": "Meine Foto-Überprüfungen",
  "mb.diagEmpty": "Keine Anfrage. Der Button „Meine Teile per Foto überprüfen“ ist auf technischen Produktseiten verfügbar.",
  "mb.partToIdentify": "Zu identifizierendes Teil",
  "mb.confirmed": "Referenz bestätigt",
  "mb.rejected": "Nicht identifiziert",
  "mb.pending": "Ausstehende Bestätigung",
  "mb.ref": "Ref. {ref}",
  "mb.aiLead": "KI-Hinweis: {ref} ({c} %)",
  "mb.seePart": "Teil ansehen",
  "promo.copyCode": "Code kopieren",
  "promo.copied": "Code kopiert!",
  "winter.myTyres": "Meine Winterreifen ansehen",
  "winter.seeTyres": "Winterreifen ansehen",
  "winter.close": "Schließen",
  "cat.reset": "Zurücksetzen",
  "cat.resetFilters": "Filter zurücksetzen",
  "cat.guideTitle": "{kw}: der OTOPIECES-Ratgeber",
  "cat.aboutTitle": "Über: {name}",
  "cat.faqTitle": "Häufige Fragen: {name}",
  "search.seeAll": "Alle Ergebnisse für „{q}“ anzeigen",
  "product.refLabel": "Art.-Nr.",
  "content.notFound": "Seite nicht gefunden",
  "content.backHome": "Zurück zur Startseite",
  "content.updatedOn": "Aktualisiert am {date}",
  "blog.title": "OTOPIECES.COM Magazin",
  "blog.intro": "Entdecken Sie unsere praktischen Ratgeber, Wartungstipps und Tricks für die Pflege Ihres Fahrzeugs.",
  "blog.searchPh": "Artikel suchen...",
  "blog.empty": "Kein Artikel gefunden",
  "blog.featured": "Top-Artikel",
  "blog.notFound": "Artikel nicht gefunden",
  "blog.backToList": "Zurück zu den Ratgebern",
  "blog.readTime": "{time} Lesezeit",
  "blog.share": "Teilen:",
  "blog.related": "Ähnliche Artikel",
  "blog.popular": "Beliebte Themen",
  "blog.catOil": "Motoröl",
  "blog.catBrakes": "Bremsen",
  "blog.catMaintenance": "Wartung",
  "blog.catElectric": "Elektrik",
  "blog.nArticles": { "one": "{n} Artikel", "other": "{n} Artikel" },
  "blog.video1": "Wie spart man beim Kauf von Autoteilen?",
  "blog.video2": "Was tun, wenn die Motorkontrollleuchte aufleuchtet",
  "blog.video3": "TOP 8 Fehler von Autobesitzern",
  "frev.l1": "Sehr enttäuschend",
  "frev.l2": "Enttäuschend",
  "frev.l3": "Okay",
  "frev.l4": "Gut",
  "frev.l5": "Ausgezeichnet",
  "frev.invalidLink": "Ungültiger Link",
  "frev.sendError": "Senden nicht möglich",
  "frev.title": "Ihre Bewertung des Zentrums",
  "frev.intro": "Hallo {name}, Ihre {n} Reifen wurden montiert bei",
  "frev.on": "am",
  "frev.order": "Bestellung",
  "frev.thanks": "Danke für Ihre Bewertung!",
  "frev.already": "Sie haben dieses Zentrum bereits bewertet.",
  "frev.replyFrom": "Antwort von {author}",
  "frev.backShop": "Zurück zum Shop",
  "frev.question": "Wie ist Ihr Montagetermin verlaufen?",
  "frev.clickStar": "Klicken Sie auf einen Stern",
  "frev.comment": "Ihr Kommentar (optional)",
  "frev.commentPh": "Empfang, Pünktlichkeit, Montagequalität…",
  "frev.submit": "Bewertung senden",
  "notif.title": "Benachrichtigungen",
  "notif.empty": "Noch keine Benachrichtigungen.",
  "notif.maintenanceLink": "Mein Wartungsheft",
  "notif.agoMin": "vor {n} Min.",
  "notif.agoH": "vor {n} Std.",
  "notif.agoD": "vor {n} T.",
  "notif.refConfirmed": "Referenz für Ihr Teil bestätigt",
  "notif.photoRequest": "Ihre Fotoprüfungsanfrage",
  "notif.fittingMoved": "Montagetermin verschoben",
  "notif.fittingConfirmed": "Montagetermin bestätigt",
  "notif.fittingTomorrow": "Reifenmontage morgen",
  "notif.maintenance": "Wartung fällig: {sub} ({vehicle})",
  "notif.k.diag_auto.title": "Referenz für Ihr Teil bestätigt",
  "notif.k.diag_auto.body": "Referenz {ref} ({brand}) durch Fotoanalyse bestätigt: {explanation}",
  "notif.k.diag_rejected.title": "Ihre Anfrage zur Fotoprüfung",
  "notif.k.diag_rejected.body": "{message}",
  "notif.k.diag_rejected_default.title": "Ihre Anfrage zur Fotoprüfung",
  "notif.k.diag_rejected_default.body": "Wir konnten das Teil auf Ihrem Foto nicht identifizieren. Bitte versuchen Sie es mit einem schärferen Foto erneut oder kontaktieren Sie unseren Kundenservice.",
  "notif.k.diag_admin.title": "Referenz für Ihr Teil bestätigt",
  "notif.k.diag_admin.body": "Unser Team hat Ihr Foto geprüft: Die zu bestellende Referenz ist {ref}{brand_suffix}. {message}",
  "notif.k.maintenance_km.title": "Wartung fällig: {sub} ({vehicle})",
  "notif.k.maintenance_km.body": "Laut Ihrem Kilometerstand ist Ihr {sub} in etwa {km} km fällig. Hier sind die passenden Teile für Ihren {vehicle}.",
  "notif.k.maintenance_now.title": "Wartung fällig: {sub} ({vehicle})",
  "notif.k.maintenance_now.body": "Laut Ihrem Kilometerstand ist Ihr {sub} jetzt fällig. Hier sind die passenden Teile für Ihren {vehicle}.",
  "notif.k.maintenance_days.title": "Wartung fällig: {sub} ({vehicle})",
  "notif.k.maintenance_days.body": "Laut Ihrem Kilometerstand ist Ihr {sub} in {days} Tagen fällig. Hier sind die passenden Teile für Ihren {vehicle}.",
  "notif.k.fit_confirmed.title": "Montagetermin bestätigt",
  "notif.k.fit_confirmed.body": "{centre} ({city}) bestätigt die Montage Ihrer Reifen am {date} — Bestellung {order}.",
  "notif.k.fit_confirmed_requested.title": "Montagetermin bestätigt",
  "notif.k.fit_confirmed_requested.body": "{centre} ({city}) bestätigt die Montage Ihrer Reifen am {date} (gewünschter Termin: {requested}) — Bestellung {order}.",
  "notif.k.fit_moved.title": "Montagetermin verschoben",
  "notif.k.fit_moved.body": "{centre} ({city}) hat Ihren Termin auf {date} verschoben — Bestellung {order}.",
  "notif.k.fit_reminder.title": "Ihre Reifenmontage ist morgen",
  "notif.k.fit_reminder.body": "Erinnerung: Termin am {date} bei {centre}, {address}.",
  "notif.k.fit_reassigned_kept.title": "Neues Montagezentrum",
  "notif.k.fit_reassigned_kept.body": "Die Montage Ihrer Reifen (Bestellung {order}) übernimmt nun {centre} — {address}. Ihr Termin am {date} bleibt bestehen und wird vom Zentrum bestätigt.",
  "notif.k.fit_reassigned_propose.title": "Neues Montagezentrum",
  "notif.k.fit_reassigned_propose.body": "Die Montage Ihrer Reifen (Bestellung {order}) übernimmt nun {centre} — {address}. Das Zentrum wird Ihnen einen Termin vorschlagen.",
  "notif.k.fit_review_reply.title": "Das Zentrum hat auf Ihre Bewertung geantwortet",
  "notif.k.fit_review_reply.body": "{centre}: „{excerpt}“",
  "notif.k.fit_cancelled_credit.title": "Montage storniert — Gutschrift erstellt",
  "notif.k.fit_cancelled_credit.body": "Gutschrift {number} über {amount} Ihrem Guthabenkonto gutgeschrieben (Bestellung {order}).",
  "notif.k.fit_card_refund.title": "Gutschrift auf Ihr Zahlungsmittel erstattet",
  "notif.k.fit_card_refund.body": "Die Gutschrift {number} über {amount} wird auf Ihre {method} erstattet (Bankbearbeitung 3 bis 10 Tage).",
  "acc.notifications": "Benachrichtigungen",
  "notif.seeAll": "Alle Benachrichtigungen anzeigen",
  "nc.kind.all": "Alle",
  "nc.kind.fitting": "Montage",
  "nc.kind.diagnostic": "Fotodiagnose",
  "nc.kind.maintenance": "Wartung",
  "nc.unreadOnly": "Nur ungelesene",
  "nc.readAll": "Alle als gelesen markieren",
  "nc.prefs": "Einstellungen",
  "nc.markRead": "Als gelesen markieren",
  "nc.markUnread": "Als ungelesen markieren",
  "nc.delete": "Löschen",
  "nc.empty": "Keine Benachrichtigungen für diesen Filter.",
  "nc.prev": "Zurück",
  "nc.next": "Weiter",
  "nc.pageOf": "Seite {page} / {pages}",
  "nc.prefsTitle": "Benachrichtigungseinstellungen",
  "nc.prefsIntro": "Wählen Sie für jede Benachrichtigungsart, ob Sie sie auch per E-Mail oder nur über die Glocke auf der Website erhalten möchten.",
  "nc.emailAndBell": "E-Mail + Glocke",
  "nc.bellOnly": "Nur Glocke",
  "nc.transactionalNote": "Unverzichtbare E-Mails (Bestellbestätigung, Versand, Rechnung, Gutschrift, Passwort) werden immer gesendet.",
  "nc.ch.diagnostic": "Fotodiagnose",
  "nc.chDesc.diagnostic": "Referenz bestätigt oder Prüfanfrage von unserem Team bearbeitet.",
  "nc.ch.maintenance": "Fällige Wartung",
  "nc.chDesc.maintenance": "Wartungserinnerungen anhand des Kilometerstands Ihrer Fahrzeuge.",
  "nc.ch.fitting": "Reifenmontage",
  "nc.chDesc.fitting": "Termin bestätigt oder verschoben, Erinnerung am Vortag, Zentrumswechsel.",
  "nc.ch.reviews": "Bewertungen & Antworten",
  "nc.chDesc.reviews": "Einladungen zur Bewertung sowie Antworten des Zentrums oder unseres Teams auf Ihre Bewertungen.",
  "nc.ch.alerts": "Preisalarme, Wunschliste & Fragen",
  "nc.chDesc.alerts": "Preissenkung oder Wiederverfügbarkeit eines beobachteten Artikels, Antworten auf Ihre Produktfragen.",
  "ps.title": "Partnerzentrum-Bereich",
  "ps.invalidLink": "Ungültiger Link",
  "ps.savedSchedule": "Zeiten gespeichert: Kunden können jetzt einen Termin bei Ihnen buchen.",
  "ps.saveFailed": "Speichern nicht möglich",
  "ps.savedLang": "Sprache gespeichert: {lang}.",
  "ps.langFailed": "Sprache nicht gespeichert",
  "ps.perTyre": "/ Reifen",
  "ps.langHint": "Sprache dieses Bereichs und der E-Mails, die wir Ihnen senden",
  "ps.langLabel": "Sprache",
  "ps.slotsTitle": "Meine Montagetermine",
  "ps.slotsIntro": "Geben Sie Ihre Öffnungszeiten pro Tag an: Kunden wählen bei der Bestellung einen freien Termin, Sie erhalten eine E-Mail zur Bestätigung.",
  "ps.upcomingTitle": "Nächste Termine",
  "ps.noUpcoming": "Keine anstehenden Termine.",
  "ps.nTyres": "{n} Reifen",
  "ps.toConfirm": "Zu bestätigen",
  "ps.confirmed": "Bestätigt",
  "ps.confirm": "Bestätigen",
  "ps.edit": "Ändern",
  "ps.reviewsTitle": "Bewertungen meiner Kunden",
  "ps.reviewsIntro": "Ihre Antworten sind öffentlich (für Kunden bei der Zentrumswahl sichtbar); der Kunde wird bei Ihrer ersten Antwort per E-Mail informiert.",
  "ps.noReviews": "Noch keine Bewertungen.",
  "ps.slotDuration": "Termindauer",
  "ps.leadDays": "Mindestvorlauf (Tage, Reifenlieferung)",
  "ps.capacity": "Fahrzeuge pro Termin",
  "ps.weekPreset": "Musterwoche (Mo–Fr 8–12 / 14–18, Sa 9–12)",
  "ps.addRange": "Zeitraum",
  "ps.closed": "Geschlossen",
  "ps.rangeError": "Jeder Zeitraum muss nach dem Beginn enden.",
  "ps.saveSchedule": "Zeiten speichern",
  "ps.ofScore": "{n} % der Bewertung",
  "ps.noDelay": "Noch keine Bestätigung gemessen",
  "ps.delayUnderHour": "Durchschnittliche Bestätigungsdauer: unter einer Stunde",
  "ps.delayAvg": "Durchschnittliche Bestätigungsdauer: {d} (100 bei ≤ 12 h, 0 über 96 h)",
  "ps.dayShort": "T",
  "ps.relTitle": "Meine Zuverlässigkeit",
  "ps.relWindow": "über die letzten {n} Tage, in Echtzeit aktualisiert",
  "ps.relIntro": "Kunden sehen zuerst die zuverlässigsten Zentren. Eine Bewertung „Beobachten“ (unter 40) bei mindestens {n} Bestellungen blendet das Zentrum vorübergehend beim Checkout aus.",
  "ps.visible": "Kunden angeboten",
  "ps.hidden": "Beim Checkout ausgeblendet",
  "ps.since": "seit {d}",
  "ps.relEmpty": "Noch keine Bestellung im Zeitraum: Ihre Bewertung erscheint nach der ersten Montage.",
  "ps.barConfirmed": "Bestätigte Termine",
  "ps.confirmedOf": "{c} bestätigt von {o} Bestellung(en)",
  "ps.pendingN": "{n} warten auf Ihre Bestätigung",
  "ps.barDelay": "Reaktionsgeschwindigkeit",
  "ps.barKept": "Behaltene Bestellungen",
  "ps.reassignedN": "{n} Bestellung(en) wegen fehlender Antwort einem anderen Zentrum zugewiesen",
  "ps.noReassigned": "Keine Bestellung neu zugewiesen — perfekt",
  "ps.pointsTitle": "Verbesserungspunkte",
  "ps.keepGoing": "Weiter so",
  "ps.excellent": "Ausgezeichnete Bewertung: Sie stehen bei Kunden in Ihrer Nähe ganz oben.",
  "ps.ratingLine": "Kundenbewertung: {avg}/5 aus {count} Bewertungen · {upcoming} anstehende Termine.",
  "ps.histEmpty": "Verlauf ab der ersten Woche mit Bestellungen verfügbar.",
  "ps.histTitle": "Entwicklung der Bewertung über {n} Wochen",
  "ps.calTitle": "Meine Termine zu meinem Kalender hinzufügen",
  "ps.calIntro": "Abonnieren Sie Ihren Kalender mit diesem Link: Montagen (bestätigt und offen) erscheinen automatisch in Google Kalender, Outlook oder Apple Kalender, stündlich aktualisiert.",
  "ps.copied": "Kopiert",
  "ps.copyLink": "Link kopieren",
  "ps.subscribe": "Abonnieren (Apple / Outlook)",
  "ps.downloadIcs": ".ics herunterladen",
  "ps.calGoogle": "Weitere Kalender (+) → „Per URL“ → Link einfügen.",
  "ps.calOutlook": "Kalender hinzufügen → „Aus dem Web abonnieren“ → Link einfügen.",
  "ps.calApple": "Ablage → Neues Kalenderabonnement, oder „Abonnieren“ klicken.",
  "ps.sendFailed": "Senden nicht möglich",
  "ps.deleteReplyConfirm": "Ihre Antwort löschen?",
  "ps.editReply": "Meine Antwort ändern",
  "ps.reply": "Antworten",
  "ps.replyPlaceholder": "Vielen Dank für Ihr Feedback…",
  "ps.publicReply": "öffentliche Antwort",
  "ps.customerNotified": "der Kunde wird per E-Mail informiert",
  "ps.publish": "Veröffentlichen",
  "ps.stValidated": "Bestätigt am {d}",
  "ps.stDisputed": "Beanstandet am {d} — in Bearbeitung",
  "ps.stResolved": "Beanstandung bearbeitet am {d}",
  "ps.actionFailed": "Aktion nicht möglich",
  "ps.stFittings": {"one": "{count} Montage", "other": "{count} Montagen"},
  "ps.stUpcoming": "{n} anstehend",
  "ps.currentMonth": "laufender Monat",
  "ps.reason": "Grund:",
  "ps.answer": "Antwort:",
  "ps.validateConfirm": "Abrechnung {m} ({a} inkl. MwSt.) bestätigen? Dies ist endgültig.",
  "ps.validate": "Abrechnung bestätigen",
  "ps.dispute": "Beanstanden",
  "ps.disputeReason": "Grund der Beanstandung (fehlende Montage, falscher Betrag…)",
  "ps.disputePlaceholder": "Z. B.: Die Montage der Bestellung OP-… vom 12.09. fehlt in der Abrechnung.",
  "ps.sendDispute": "Beanstandung senden",
  "ps.cancel": "Abbrechen",
  "ps.stTitle": "Meine Monatsabrechnungen",
  "ps.stIntro": "Jede Abrechnung fasst die bestätigten und durchgeführten Montagen in Ihrem Zentrum und den uns zu berechnenden Betrag (inkl. MwSt.) zusammen. Bestätigen Sie sie nach Monatsende vor Ihrer Rechnungsstellung oder beanstanden Sie sie bei Fehlern.",
  "ps.trend": "{d} Pkt. seit {since}",
  "rel.excellent": "Ausgezeichnet",
  "rel.good": "Gut",
  "rel.average": "Mittel",
  "rel.watch": "Beobachten",
  "rel.noData": "Nicht genügend Daten",
  "rel.tip": "Bestätigung {c} % · Antwortzeit {d}/100 · Erlittene Neuzuweisungen {r} ({rs}/100) · {n} Bestellung(en)",
  "rel.detail": "Best. {c} % · Zeit {d} · Neuzuw. {r}",
  "rel.weekTip": "Woche vom {d}: {s}/100 ({l}, {n} Bestellung(en))",
  "nc.pushEnabledBg": "Benachrichtigungen aktiviert (auch bei geschlossener Website)",
  "nc.pushTest": "Testbenachrichtigung senden",
  "nc.pushTestResult": "Testbenachrichtigung an {sent} von {devices} Gerät(en) gesendet.",
  "nc.pushTestNone": "Kein abonniertes Gerät: Aktivieren Sie zuerst die Benachrichtigungen auf diesem Gerät.",
  "ps.pushIntro": "Werden Sie auf diesem Gerät benachrichtigt, auch bei geschlossenem Bereich, sobald ein Kunde einen Montagetermin bucht, verschiebt oder storniert oder Ihnen eine Montage zugewiesen wird.",
  "nc.ch.digest": "Wöchentliche Zusammenfassung",
  "nc.chDesc.digest": "Jeden Montagmorgen eine E-Mail mit Ihren ungelesenen Benachrichtigungen der Woche (standardmäßig aus).",
  "nc.digestOn": "An",
  "nc.digestOff": "Aus",
  "nc.pushTitle": "Browser-Benachrichtigungen",
  "nc.pushDesc": "Erhalten Sie eine Meldung auf Ihrem Gerät, sobald ein Montagetermin bestätigt oder verschoben wird oder eine neue Benachrichtigung eintrifft — auch bei geschlossener Website (Web Push).",
  "nc.pushEnable": "Browser-Benachrichtigungen aktivieren",
  "nc.pushEnabled": "Browser-Benachrichtigungen aktiviert",
  "nc.pushDisable": "Deaktivieren",
  "nc.pushDenied": "Vom Browser blockiert: Erlauben Sie Benachrichtigungen in den Website-Einstellungen.",
  "nc.pushUnsupported": "Ihr Browser unterstützt keine Benachrichtigungen.",
  "track.title": "Sendungsverfolgung",
  "track.created": "Bestellung bestätigt",
  "track.createdDesc": "Ihre Zahlung wurde bestätigt, wir bereiten Ihre Bestellung vor.",
  "track.processing": "In Vorbereitung",
  "track.processingDesc": "Ihre Teile werden in unserem Lager geprüft und verpackt.",
  "track.handed_over": "Paket an Versanddienst übergeben",
  "track.shipped": "Versendet",
  "track.shippedDesc": "Ihr Paket ist unterwegs.",
  "track.transit": "Unterwegs",
  "track.delivered": "Zugestellt",
  "track.deliveredDesc": "Ihr Paket wurde zugestellt. Gute Fahrt!",
  "track.pending": "Ausstehend",
  "track.eta": "Voraussichtliche Lieferung: {d}",
  "track.carrierLink": "Bei {carrier} verfolgen",
  "track.noNumber": "Die Sendungsnummer erhalten Sie, sobald Ihre Bestellung versendet wird.",
  "track.help": "Fragen zu Ihrer Lieferung? Alle Schritte werden hier in Echtzeit angezeigt.",
  "track.lastUpdate": "Letzte Aktualisierung: {d}",
  "nc.ch.cart": "Warenkorb-Erinnerung",
  "nc.chDesc.cart": "Eine E-Mail, wenn Artikel 24 Stunden in Ihrem Warenkorb liegen.",
  "nc.kind.delivery": "Lieferung",
  "nc.ch.delivery": "Sendungsverfolgung",
  "nc.chDesc.delivery": "Neuer Lieferschritt zu Ihrer Bestellung (Vorbereitung, Transport, Zustellung).",
  "notif.k.delivery_step.title": "Neuer Lieferschritt — Bestellung {order}",
  "notif.k.delivery_step.body": "{step}{loc} Verfolgen Sie Ihr Paket in Echtzeit unter Meine Bestellungen.",
  "notif.k.delivery_processing.title": "Ihre Bestellung {order} wird vorbereitet",
  "notif.k.delivery_processing.body": "Ihre Teile werden in unserem Lager geprüft und verpackt. Nächster Schritt: Versand.",
  "notif.k.delivery_shipped.title": "Ihre Bestellung {order} wurde versendet",
  "notif.k.delivery_shipped.body": "Ihr Paket ist unterwegs{loc}. Die Sendungsnummer finden Sie unter Meine Bestellungen.",
  "notif.k.delivery_delivered.title": "Ihre Bestellung {order} wurde zugestellt",
  "notif.k.delivery_delivered.body": "Ihr Paket ist angekommen. Gute Fahrt! Bewerten Sie gern Ihre Teile.",
  "paylink.invalid": "Dieser Zahlungslink ist ungültig.",
  "paylink.fillCard": "Bitte alle Kartendaten ausfüllen.",
  "paylink.failed": "Die Zahlung konnte nicht durchgeführt werden.",
  "paylink.paid": "Diese Bestellung ist bereits bezahlt. Vielen Dank!",
  "paylink.expired": "Dieser Zahlungslink ist abgelaufen. Kontaktieren Sie uns für einen neuen.",
  "paylink.revoked": "Dieser Link wurde durch einen neuen ersetzt: siehe Ihre letzte E-Mail.",
  "paylink.cancelled": "Diese Bestellung wurde storniert.",
  "paylink.successTitle": "Zahlung bestätigt",
  "paylink.successBody": "Danke! Ihre Bestellung {o} ist bestätigt und wird sofort vorbereitet. Eine Bestätigungs-E-Mail wurde gesendet.",
  "paylink.orderFor": "Bestellung vorbereitet für {n}",
  "paylink.toPay": "Zu zahlen",
  "paylink.cardTitle": "Sichere Kartenzahlung",
  "paylink.holder": "Name des Karteninhabers",
  "paylink.payNow": "{a} bezahlen",
  "paylink.secure": "Verschlüsselte Verbindung · Ihre Kartendaten werden nie gespeichert.",
  "orders.awaitingPayment": "Zahlung ausstehend",
  "orders.payNow": "Jetzt bezahlen",
  "checkout.sumupInfo": "Sie werden zur sicheren SumUp-Zahlungsseite weitergeleitet, um Ihre Kartendaten einzugeben. Ihre Bestellung ist bestätigt, sobald die Zahlung akzeptiert wurde.",
  "checkout.walletCoversAll": "Ihr Guthaben deckt die gesamte Bestellung ab: Eine Kartenzahlung ist nicht erforderlich.",
  "checkout.redirecting": "Weiterleitung zur sicheren Zahlung…",
  "checkout.errPayment": "Die Bestellung ist erfasst, aber die Zahlung konnte nicht gestartet werden. Versuchen Sie es erneut oder bezahlen Sie später unter « Meine Bestellungen ».",
  "checkout.retryPayment": "Zahlung erneut versuchen",
  "paylink.sumupInfo": "Sie werden zur sicheren SumUp-Zahlungsseite weitergeleitet (Bankkarte, Apple Pay, Google Pay).",
  "payret.checking": "Ihre Zahlung wird geprüft…",
  "payret.checkingHint": "Bitte warten Sie einige Sekunden, wir bestätigen die Zahlung bei SumUp.",
  "payret.paidTitle": "Zahlung bestätigt !",
  "payret.paidBody": "Vielen Dank für Ihre Bestellung. Eine Bestätigungs-E-Mail wurde Ihnen gesendet und Ihre Bestellung wird ab sofort vorbereitet.",
  "payret.failedTitle": "Zahlung nicht erfolgreich",
  "payret.failedBody": "Die Zahlung wurde abgelehnt oder storniert. Es wurde kein Betrag abgebucht. Ihre Artikel bleiben reserviert: Sie können es erneut versuchen.",
  "payret.pendingTitle": "Zahlung wird noch bestätigt",
  "payret.pendingBody": "Wir haben die Bestätigung von SumUp noch nicht erhalten. Wenn Sie bezahlt haben, wird Ihre Bestellung in einigen Minuten automatisch auf « Bezahlt » gesetzt.",
  "payret.retry": "Zahlung erneut versuchen",
  "payret.later": "Später bezahlen",
  "payret.errorTitle": "Bestellung nicht gefunden",
  "orders.refundCard": "Bestellung auf Ihre Bankkarte erstattet ({a} €) — Gutschrift {n}.",
  "orders.refundCardPartial": "Teilrückerstattung von {a} € auf Ihre Bankkarte vorgenommen — Gutschrift {n}.",
  "orders.creditNotePdf": "Gutschrift herunterladen (PDF)",
  "product.viewSpecs": "Technische Daten",
  "product.fitOk": "Passt zu Ihrem Fahrzeug",
  "product.fitUniversal": "Universalprodukt: passt zu allen Fahrzeugen",
  "product.fitKo": "Passt nicht zu Ihrem Fahrzeug",
  "product.fitSeeCompatible": "Passende Teile ansehen",
  "product.fitChangeVehicle": "Fahrzeug ändern",
  "product.fitSelectHint": "Wählen Sie Ihr Fahrzeug, um die Kompatibilität zu prüfen",
  "product.fitSelectCta": "Mein Fahrzeug wählen",
  "cmp.check": "Vergleichen",
  "cmp.checked": "Im Vergleich",
  "cmp.added": "Zum Vergleich hinzugefügt ({n}/{max})",
  "cmp.removed": "Aus dem Vergleich entfernt",
  "cmp.maxReached": "Sie können maximal {max} Artikel vergleichen",
  "cmp.sameSub": "Vergleichen Sie nur Artikel derselben Unterkategorie",
  "cmp.open": "Vergleichen",
  "cmp.barTitle": "Vergleich",
  "cmp.barHint": "Wählen Sie 2 bis {max} Artikel derselben Unterkategorie",
  "cmp.barCompare": "Vergleichen ({n})",
  "cmp.barNeedTwo": "Fügen Sie mindestens 2 Artikel hinzu",
  "cmp.colHeader": "Merkmal",
  "cmp.specsTitle": "Technische Daten",
  "cmp.diffHint": "Hervorgehobene Zeilen zeigen Unterschiede zwischen den Artikeln.",
  "cmp.intro2": "{n}/{max} Artikel · setzen Sie „Vergleichen“ auf Produktkarten derselben Unterkategorie.",
  "cmp.emptyHint2": "Durchsuchen Sie den Katalog und markieren Sie „Vergleichen“ bei 2 bis {max} Artikeln derselben Unterkategorie.",
  "header.fastShipping": "Schnelle Lieferung in 2-5 Tagen",
  "product.deliverySubFast": "2 bis 5 Werktage",
  "cart.fastShipping": "Schnelle Lieferung in 2-5 Tagen",
  "cart.freeShippingReached": "Kostenloser Versand freigeschaltet!",
  "header.deliveryCountry": "Lieferland",
  "header.freeFromShort": "gratis ab {n} €",
  "sess.title": "Verbundene Geräte",
  "sess.hint": "Aktuell angemeldete Sitzungen Ihres Kontos. Melden Sie ein unbekanntes Gerät ab – oder alle anderen auf einmal.",
  "sess.logoutEverywhere": "Überall abmelden",
  "sess.logout": "Abmelden",
  "sess.thisDevice": "Dieses Gerät",
  "sess.lastSeen": "Letzte Aktivität",
  "sess.remembered": "angemeldet bleiben",
  "sess.revoked": "Gerät abgemeldet",
  "sess.revokedAll": "{n} Gerät(e) abgemeldet",
  "sess.confirmAll": "Alle anderen Geräte abmelden? Hier bleiben Sie angemeldet.",
  "sess.error": "Aktion fehlgeschlagen, bitte erneut versuchen",
  "sess.empty": "Keine aktive Sitzung",
  "cart.remove": "Entfernen",
  "cat.specs": "Technische Daten",
  "cat.specsHint": "Verfeinern nach Abmessung, Typ oder technischer Referenz.",
  "cat.showMore": "Mehr anzeigen ({n})",
  "cat.showLess": "Weniger anzeigen",
  "garage.savedToast": "Fahrzeug in Ihrer Garage gespeichert",
  "garage.restoredToast": "Ihr {v} wurde aus Ihrem Konto wiederhergestellt",
  "garage.myVehicles": "Meine Fahrzeuge",
  "garage.manage": "Meine Garage verwalten",
  "cart.forVehicle": "Teile für Ihr Fahrzeug",
  "equiv.search": "Filtern…",
  "equiv.allBrands": "Alle Marken ({n})",
  "equiv.brand": "Marke",
  "equiv.ref": "Referenz",
  "equiv.type": "Typ",
  "equiv.oem": "OEM-Hersteller",
  "equiv.alt": "Entsprechung",
  "equiv.unknownBrand": "—",
  "equiv.empty": "Keine Referenz entspricht diesem Filter.",
  "equiv.seeAll": "Alle {n} Referenzen anzeigen ↓",
  "equiv.moreAlt": "+{n} Entsprechungen",
  "equiv.brandLink": "Alle Teile anzeigen, die {b} referenzieren",
  "search.equivBrand": "Teile mit Referenz {b}",
  "search.equivHint": "Teile der Marke {b} und Teile anderer Hersteller, die eine gleichwertige Referenz {b} angeben.",
  "cart.fitOk": "Kompatibel mit Ihrem {v}",
  "cart.fitNo": "Nicht bestätigt für Ihren {v}",
  "cart.fitUniversal": "Universelles Teil · alle Fahrzeuge",
  "cart.fitCheck": "Produktseite prüfen",
  "cart.fitWarn": { one: "{n} Artikel ist nicht bestätigt für Ihren {v}: Bitte prüfen Sie die Kompatibilität vor der Bestellung.", other: "{n} Artikel sind nicht bestätigt für Ihren {v}: Bitte prüfen Sie ihre Kompatibilität vor der Bestellung." },
  "alt.compatible": "Alternative, kompatibel mit Ihrem {v} bei {brand}",
  "alt.samePrice": "gleicher Preis",
  "alt.morePerUnit": "+{d} € / Einheit",
  "cart.garageSwitch": "Fahrzeug wechseln (meine Garage)",
  "cart.garagePick": "Ein Fahrzeug aus meiner Garage wählen…",
  "cart.garageHint": "Die Kompatibilität der Artikel wird sofort neu geprüft.",
  "notify.button": "Benachrichtigen, wenn wieder verfügbar",
  "notify.title": "Benachrichtigung bei Verfügbarkeit",
  "notify.text": "Hinterlassen Sie Ihre E-Mail: Wir schreiben Ihnen, sobald dieses Teil wieder verfügbar ist (einmalig, unverbindlich).",
  "notify.emailPh": "ihre@email.de",
  "notify.submit": "Benachrichtigen",
  "notify.done": "Notiert! Sie erhalten eine E-Mail, sobald das Teil wieder auf Lager ist.",
  "notify.already": "Sie sind für dieses Teil bereits eingetragen.",
  "notify.subscribed": "Benachrichtigung aktiv: Sie werden per E-Mail informiert",
  "notify.cancel": "Benachrichtigung abbestellen",
  "notify.error": "Ihre Anfrage konnte nicht gespeichert werden. Bitte prüfen Sie die E-Mail-Adresse.",
  "notify.priceButton": "Benachrichtigen, wenn der Preis sinkt",
  "notify.priceTitle": "Preisalarm",
  "notify.priceText": "Hinterlassen Sie Ihre E-Mail: Wir schreiben Ihnen, sobald dieses Teil günstiger wird (einmalig, unverbindlich).",
  "notify.priceDone": "Notiert! Sie erhalten eine E-Mail, wenn der Preis sinkt.",
  "notify.priceAlready": "Sie beobachten den Preis dieses Teils bereits.",
  "notify.priceSubscribed": "Preisalarm aktiv: Sie werden per E-Mail informiert",
  "acc.referral": "Freunde werben",
  "share.rewardHint": "−{p} % geschenkt, wenn ein Freund über Ihren Link erstmals bestellt.",
  "share.rewardMore": "Meine Prämien",
  "share.rewardGuest": "Anmelden: −{p} % geschenkt, wenn ein Freund über Ihren Link bestellt.",
  "share.rewardLogin": "Anmelden",
  "share.refTitle": "Teilen und −{p} % sichern",
  "share.refHow": "Jedes Mal, wenn ein Freund nach dem Öffnen eines von Ihnen geteilten Links (Seite, Produkt, Vergleich, Ratgeber) seine erste Bestellung aufgibt, erhalten Sie per E-Mail einen persönlichen Code über −{p} %, gültig {d} Tage. Die Teilen-Buttons der Website fügen Ihren Code automatisch hinzu.",
  "share.refDisabled": "Das Programm ist vorübergehend ausgesetzt.",
  "share.refWhatsapp": "Hier bestelle ich meine Autoteile, schau mal:",
  "share.refTip": "Tipp: Teilen Sie direkt eine Produktseite oder Ihre Fahrzeugauswahl — der Link enthält bereits Ihren Code.",
  "share.refTotal": "Erhaltene Prämien",
  "share.refActive": "Einlösbare Codes",
  "share.refRewards": "Meine Codes",
  "share.refEmpty": "Noch keine Prämie: Teilen Sie Ihre Lieblingsteile mit Freunden!",
  "share.refStatus_active": "Einlösbar",
  "share.refStatus_used": "Eingelöst",
  "share.refStatus_expired": "Abgelaufen",
  "share.refFriend": "Freund {f} · {d}",
  "share.refUntil": "bis {d}",
  "share.tier_none": "Noch kein Rang",
  "share.tier_bronze": "Bronze-Werber",
  "share.tier_silver": "Silber-Werber",
  "share.tier_gold": "Gold-Werber",
  "share.badgeFriends": "{n} Freund(e) gewonnen",
  "share.badgeNext": "Noch {n} Freund(e) bis {tier}",
  "share.badgeMax": "Höchster Rang erreicht — danke!",
  "share.badgeLevels": "Bronze ab 1 Freund · Silber ab 3 · Gold ab 10",
  "acc.alerts": "Meine Benachrichtigungen",
  "alerts.intro": "Ihre „Benachrichtigen“-Alarme: wieder verfügbar und Preissenkung. Jeder Alarm sendet eine einzige E-Mail und verschwindet dann aus dieser Liste.",
  "alerts.active": { one: "{n} aktiver Alarm", other: "{n} aktive Alarme" },
  "alerts.empty": "Kein aktiver Alarm. Klicken Sie auf einer Produktseite auf „Benachrichtigen“, um über Verfügbarkeit oder Preissenkung informiert zu werden.",
  "alerts.kindStock": "Wieder verfügbar",
  "alerts.kindPrice": "Preissenkung",
  "alerts.remove": "Entfernen",
  "alerts.removeAll": "Alle entfernen",
  "alerts.removed": "Alarm entfernt",
  "alerts.removedAll": "Alle Alarme entfernt",
  "alerts.error": "Aktion fehlgeschlagen, bitte erneut versuchen",
  "alerts.since": "seit {d}",
  "alerts.priceWatch": "Beobachteter Preis: {p} €",
  "alerts.now": "heute",
  "alerts.backSoon": "Wieder auf Lager — E-Mail unterwegs",
  "alerts.history": "Gesendete Alarme (letzte 90 Tage)",
  "alerts.sentOn": "gesendet am {d}",
  "wl.priceAlerts": "Preisalarm für die ganze Liste",
  "wl.priceAlertsHint": "E-Mail erhalten, sobald ein Teil Ihrer Wunschliste günstiger wird",
  "wl.priceAlertsDone": "Preisalarm für {n} Teil(e) aktiviert ({a} bereits beobachtet). Zu finden unter Meine Benachrichtigungen.",
  "equiv.showMore": "Mehr anzeigen ({n} weitere Referenzen)",
  "equiv.showLess": "Weniger anzeigen",
  "spec.equivalences": "Vergleichsnummern",
  "header.matchesEan": "Entspricht der EAN-Code ",
  "product.compatVerified": { one: "Kompatibilitäten geprüft über {n} gleichwertiges Teil", other: "Kompatibilitäten geprüft über {n} gleichwertige Teile" },
  "equiv.compareTitle": "Gleichwertigkeiten nebeneinander vergleichen",
  "equiv.compareSub": "{n} gleichwertige Teile · die hervorgehobene Spalte ist das betrachtete Teil",
  "equiv.openComparator": "Im Vergleich öffnen",
  "equiv.current": "Betrachtetes Teil",
  "equiv.colBrand": "Marke",
  "equiv.colRef": "Referenz",
  "equiv.colPrice": "Preis inkl. MwSt.",
  "equiv.colRating": "Kundenbewertungen",
  "equiv.colDelivery": "Lieferung",
  "equiv.colStock": "Lagerbestand",
  "equiv.colType": "Typ",
  "equiv.cheapest": "Am günstigsten",
  "equiv.bestRated": "Am besten bewertet",
  "equiv.fastest": "am schnellsten",
  "equiv.bestMarket": "Bester Marktpreis",
  "equiv.stockLine": "{w} Lager",
  "equiv.stockSupplier": " · +{s} Anbieter",
  "equiv.outOfStock": "Nicht auf Lager",
  "equiv.supplierDelay": "In {n} Tagen (Anbieter)",
  "equiv.ship24": "Versand innerhalb von 24 Std.",
  "equiv.unavailable": "Nicht verfügbar",
  "equiv.viewProduct": "Zur Produktseite",
  "equiv.hideCompare": "Vergleich ausblenden",
  "equiv.showCompare": "Vergleich anzeigen",
  "common.close": "Schließen",
  "scan.title": "EAN-Barcode scannen",
  "scan.hint": "Platzieren Sie den Barcode des Teils oder seiner Verpackung im Rahmen: Die Produktseite öffnet sich automatisch.",
  "scan.denied": "Zugriff auf die Kamera verweigert. Bitte erlauben Sie die Kamera in Ihrem Browser und versuchen Sie es erneut.",
  "scan.unavailable": "Kamera auf diesem Gerät nicht verfügbar. Geben Sie den EAN-Code in die Suche ein.",
  "scan.found": "Teil gefunden: {name}",
  "equiv.share": "Vergleich teilen",
  "equiv.shareWhatsapp": "Auf WhatsApp senden",
  "equiv.shareCopy": "Link kopieren",
  "equiv.shareCopied": "Link des Vergleichs kopiert",
  "equiv.shareText": "Kannst du mir sagen, welches Teil ich wählen soll? OTOPIECES-Vergleich: {names}",
  'cmp.shared': { one: 'Geteilter Vergleich — {n} Teil', other: 'Geteilter Vergleich — {n} Teile' },
  "cmp.shareTitle": "Diesen Vergleich teilen",
  "fb.title": "Unsere Top-Marken",
  "fb.all": "Alle Marken",
  "fb.nav": "Teilemarken",
  "fb.parts": "{b} Teile",
  "fb.logo": "{b} Logo",
  "seo.defaultTitle": "Günstige Autoteile online — Ersatzteile für alle Marken",
  "seo.defaultDesc": "Kfz-Ersatzteile zum besten Preis auf OTOPIECES.COM: Bremsen, Filter, Motor, Reifen… Suche nach Fahrzeug oder Kennzeichen, Lieferung in 2-5 Tagen, 14 Tage Rückgabe.",
  "vb.title": "Autoteile nach Fahrzeugmarke",
  "vb.meta": "Wählen Sie Ihre Fahrzeugmarke (Renault, Peugeot, Volkswagen, BMW, Citroën…), um alle Modelle und passende Ersatzteile zu finden.",
  "vb.crumb": "Fahrzeugmarken",
  "vb.intro": "Wählen Sie die Marke Ihres Autos, um alle Modelle und passenden Ersatzteile zu entdecken: Bremsen, Filter, Motor, Reifen…",
  "vb.searchPh": "Marke suchen…",
  "vb.popular": "Meistverkaufte Marken",
  "vb.all": "Alle Marken ({n})",
  "vb.models": { "one": "{n} Modell", "other": "{n} Modelle" },
  "vb.brandTitle": "Günstige {b} Autoteile — alle Modelle",
  "vb.brandFallback": "Fahrzeugmarke",
  "vb.brandH1": "{b} Autoteile",
  "vb.brandStats": "{m} Modell(e) · {p} passende(s) Teil(e)",
  "vb.brandExcerpt": "Wählen Sie unten Ihr {b}-Modell, dann Baujahr und Motorisierung, um nur die Teile anzuzeigen, die exakt zu Ihrem Fahrzeug passen.",
  "vb.brandEmpty": "Die {b}-Modelle kommen bald.",
  "vb.selectVehicle": "Fahrzeug auswählen",
  "vb.topParts": "Meistgefragte passende {b}-Teile",
  "vb.faqTitle": "Häufige Fragen zu {k}",
  "vb.faqParts": "{b}-Teilen",
  "vb.notFound": "Marke nicht gefunden.",
  "vb.seeAll": "Alle Marken anzeigen",
  "vm.notFound": "Modell nicht gefunden.",
  "vm.seeBrandModels": "Modelle der Marke anzeigen",
  "vm.useVehicle": "Dieses Fahrzeug für den gesamten Katalog verwenden",
  "vm.shareParts": "Passende Teile teilen",
  "vm.share": "Teilen…",
  "vm.empty": "Für dieses Modell sind derzeit keine Teile gelistet.",
  "vm.otherModels": "Andere {b}-Modelle anzeigen",
  "vm.engineEmpty": "Keine Teile für die Motorisierung „{e}“ gelistet.",
  "vm.allEngines": "Alle Motorisierungen anzeigen",
  "vm.frequent": "Häufige Suchen",
  "vm.wholeCategory": "Ganze Kategorie",
  "vm.faqTitle": "Häufige Fragen — {car} Teile",
  "vm.faqFitQ": "Wie kann ich sicher sein, dass ein Teil zu meinem {car} passt?",
  "vm.faqFitA": "Jedes Teil auf dieser Seite ist für den {model} gelistet. Klicken Sie oben auf Ihre Motorisierung (oder geben Sie Ihr Kennzeichen auf der Startseite ein): Nur die mit Ihrer Version kompatiblen Referenzen bleiben sichtbar.",
  "vm.faqPartsQ": "Welche Teile gibt es für den {car}?",
  "vm.faqPartsA": "Der {model}-Katalog umfasst derzeit: {cats}. Er wird regelmäßig um neue Referenzen erweitert.",
  "vm.faqPartsEmpty": "Der {model}-Katalog befindet sich im Aufbau.",
  "vm.faqDeliveryQ": "Wie lange dauert die Lieferung?",
  "vm.faqDeliveryA": "Lagernde Teile werden innerhalb von 24 h versandt und in 2 bis 5 Werktagen geliefert. Sie können bei der Bestellung auch einen Einbau in einer Partnerwerkstatt buchen.",
  "vm.h1": "{car} Autoteile",
  "vm.intro": "Nachfolgend finden Sie alle geprüften Ersatzteile für den {car}. Wählen Sie Ihre Motorisierung, um nur die exakt passenden Referenzen anzuzeigen.",
  "vm.stats": "{e} Motorisierung(en) · {p} passende(s) Teil(e)",
  "vm.filtered": "{n} Teil(e){e}",
  "vm.forEngine": " für {e}",
  "vm.added": "In den Warenkorb gelegt",
  "vm.addError": "Konnte nicht in den Warenkorb gelegt werden",
  "pp.noVehicleTitle": "Kein Fahrzeug ausgewählt",
  "pp.noVehicleText": "Wählen Sie Ihr Fahrzeug, um nur passende Teile anzuzeigen.",
  "pp.selectVehicle": "Mein Fahrzeug auswählen",
  "pp.backHome": "Zurück zur Startseite",
  "pp.title": "Zu Ihrem Fahrzeug passende Teile",
  "pp.metaTitle": "Zu Ihrem Fahrzeug passende Autoteile",
  "pp.metaDesc": "Wählen Sie Ihr Fahrzeug (Marke, Modell, Motorisierung oder Kennzeichen) und entdecken Sie 100 % passende Ersatzteile auf OTOPIECES.COM.",
  "pp.metaTitleVehicle": "{v} Autoteile",
  "pp.metaDescVehicle": "Alle zu Ihrem {v} passenden Ersatzteile: Bremsen, Filter, Motor, Kupplung… zum besten Preis auf OTOPIECES.COM.",
  "pp.categories": "Kategorien",
  "br.title": "Die günstigsten Modelle im Unterhalt: Ranking des jährlichen Teilebudgets",
  "br.h1": "Die günstigsten Modelle im Unterhalt",
  "br.crumb": "Wartungsbudget",
  "br.metaDefault": "Ranking der Fahrzeugmodelle nach geschätztem jährlichem Wartungsbudget auf Basis passender Teile.",
  "br.meta": "Ranking von {n} Modellen nach geschätztem jährlichem Wartungsbudget (passende Verschleißteile × übliche Häufigkeit). Vom günstigsten ({min}/Jahr) bis zum teuersten ({max}/Jahr), ohne Arbeitslohn.",
  "br.intro": "Für jedes Modell schätzen wir das jährliche Budget für Wartungsteile anhand der auf OTOPIECES.COM gelisteten passenden Teile: Filter, Bremsen, Zündkerzen, Riemen, Stoßdämpfer… multipliziert mit ihrer üblichen Wechselhäufigkeit. Medianpreis der passenden Teile oder „Eco“-Budget mit dem günstigsten Teil. Ohne Arbeitslohn, alle Motorisierungen zusammen.",
  "br.error": "Ranking derzeit nicht verfügbar.",
  "br.allBrands": "Alle Marken ({n})",
  "br.itemStats": "{p} von {pt} Posten geschätzt · {n} passende Teile · {e} Motorisierungen",
  "br.perYear": "/ Jahr",
  "br.eco": "Eco {v} / Jahr",
  "br.footnote": "Ranking wird jede Nacht neu berechnet{d}. Unverbindliche Schätzungen, ohne Arbeitslohn.",
  "br.lastUpdate": " · letzte Aktualisierung {d}",
  "br.ctaQ": "Besitzen Sie eines dieser Modelle?",
  "br.ctaLink": "Fügen Sie es Ihrer Garage hinzu",
  "br.ctaRest": " für ein Budget zu Ihrer exakten Motorisierung, ein Serviceheft und E-Mail-Erinnerungen.",
  "br.faqTitle": "Häufige Fragen",
  "br.faq1q": "Wie wird das Wartungsbudget berechnet?",
  "br.faq1a": "Wir berücksichtigen 22 Verschleißposten (Ölwechsel, Filter, Beläge, Scheiben, Zündkerzen, Riemen, Steuerung, Stoßdämpfer…). Für jeden Posten wird der Medianpreis der gelisteten passenden Teile durch die übliche Wechselhäufigkeit geteilt (z. B. Beläge alle 2 Jahre). Die Summe ergibt das geglättete Jahresbudget. Ein Modell kommt erst mit mindestens 3 geschätzten Posten ins Ranking.",
  "br.faq2q": "Welches Modell ist am günstigsten im Unterhalt?",
  "br.faq2a": "Nach unseren Schätzungen liegt {car} mit rund {m} Wartungsteilen pro Jahr zum Medianpreis vorn ({e} in Eco). Der Median der {n} gelisteten Modelle beträgt {med}/Jahr.",
  "br.faq3q": "Enthält das Budget den Arbeitslohn?",
  "br.faq3a": "Nein: Es handelt sich nur um das Teilebudget, alle Motorisierungen zusammen. Fügen Sie Ihr Fahrzeug Ihrer Garage hinzu, um ein Budget für Ihre exakte Motorisierung, ein Serviceheft mit Fälligkeiten in Monaten und Kilometern sowie E-Mail-Erinnerungen zu erhalten.",
  "cm.pickError": "Wählen Sie zwei oder drei Fahrzeuge aus Ihrer Garage zum Vergleichen.",
  "cm.failed": "Vergleich nicht möglich",
  "cm.title": "Teilevergleich: {v}",
  "cm.meta": "Gemeinsame und spezifische passende Teile zwischen {v}.",
  "cm.crumbGarage": "Meine Garage",
  "cm.crumb": "Modellvergleich",
  "cm.parts": "{n} Teil(e)",
  "cm.forThisEngine": " für diese Motorisierung",
  "cm.engines": " · {n} Motorisierung(en)",
  "cm.budget": "Wartungsbudget ~{m} €/Jahr",
  "cm.budgetEco": "(Eco {e} €)",
  "cm.cheapest": "am günstigsten im Unterhalt",
  "cm.budgetNone": "Wartungsbudget nicht geschätzt",
  "cm.part": "Teil",
  "cm.price": "Preis",
  "cm.exactEngine": "Meine exakte Motorisierung",
  "cm.allEngines": "Alle Motorisierungen des Modells",
  "cm.exactHint": "Es werden nur Teile für die Motorisierung jedes Fahrzeugs (oder ohne Motoreinschränkung) verglichen.",
  "cm.allHint": "Alle Teile des Modells werden verglichen, unabhängig von der Motorisierung.",
  "cm.all": "Alle ({n})",
  "cm.common2": "Für beide ({n})",
  "cm.common3": "Für alle drei ({n})",
  "cm.partial": "Für zwei von drei ({n})",
  "cm.only": "Nur {m} ({n})",
  "cm.onlyCol": "Nur {m}",
  "cm.common2Col": "Für beide",
  "cm.empty": "Keine Teile in dieser Auswahl.",
  "wl.title": "Meine Wunschliste",
  "wl.empty": "Keine Teile gespeichert. Klicken Sie auf das Herz eines Produkts, um es hier wiederzufinden.",
  "acc.addressIntro": "Ihre Adressen werden beim Bestellen vorgeschlagen. Die Standard-Lieferadresse wird automatisch vorausgefüllt.",
  "acc.walletIntro": "Ihr Guthabenkonto wird von unserem Kundenservice aufgeladen (Erstattung als Guthaben, Kulanz, Gutschein).",
  "acc.prefsNote": "Der Shop ist in 5 Sprachen und in Euro verfügbar; Ihre Einstellungen werden gespeichert.",
  "acc.proHt": "Preise netto angezeigt",
  "acc.proInvoices": "Rechnungen auf den Namen Ihres Unternehmens",
  "acc.proBadge": "Pro-Badge auf Ihrem Konto",
  "va.title": "Fahrzeug-Benachrichtigungen",
  "va.intro": "Erhalten Sie eine E-Mail, wenn neue zu Ihren Modellen passende Teile hinzugefügt werden — als Wochenübersicht (montags) oder bei jeder Ergänzung.",
  "va.empty": "Keine Fahrzeug-Benachrichtigung. Aktivieren Sie eine auf einer Modellseite.",
  "va.browse": "Fahrzeuge durchsuchen",
  "auth.showPassword": "Passwort anzeigen",
  "brands.kicker": "Unsere Hersteller",
  "brand.empty": "Kein {b}-Produkt{cat}{veh}.",
  "brand.emptyCat": " in dieser Kategorie",
  "brand.emptyVeh": " passend zu Ihrem Fahrzeug",
  "brand.seeUnfiltered": "Die {n} nicht nach Fahrzeug gefilterten Produkte anzeigen",
  "brand.relatedSearches": "Verwandte Suchen",
  "cmp.pageTitle": "Produktvergleich",
  "common.new": "Neu",
  "vm.metaDesc": "Alle passenden Ersatzteile für den {car}: {cats}. {e} Motorisierung(en) ({engines}…). Geprüfte Kompatibilität, Lieferung in 2-5 Tagen.",
  "ship.title": "Lieferung & Sendungsverfolgung",
  "ship.metaDesc": "Lieferzeiten, Versandkosten und Transporteure bei OTOPIECES.COM.",
  "ship.metaFree": "Kostenlose Lieferung ab {free}.",
  "ship.eyebrow": "Lieferung",
  "ship.heading": "Schnelle Lieferung mit Sendungsverfolgung",
  "ship.headingFree": "Schnelle Lieferung mit Sendungsverfolgung, kostenlos ab {free}",
  "ship.intro": "Versand innerhalb von 24 Werktagsstunden aus unserem Lager in Frankreich. Wählen Sie den passenden Transporteur.",
  "ship.fees": "Versandkosten",
  "ship.feesFree": "{fee} · kostenlos ab {free}",
  "ship.avgDelay": "Durchschnittliche Lieferzeit",
  "ship.avgDelayValue": "2 bis 5 Werktage",
  "ship.insured": "Versichertes Paket",
  "ship.insuredValue": "Bruch oder Verlust wird erstattet",
  "ship.how": "Wie läuft es ab?",
  "ship.s1": "Bestellung bestätigt",
  "ship.s1Text": "Sofortige Bestätigung per E-Mail mit Ihrer Bestellnummer.",
  "ship.s2": "Vorbereitung",
  "ship.s2Text": "Teile werden innerhalb von 24 Werktagsstunden in unserem Lager geprüft und verpackt.",
  "ship.s3": "Versand",
  "ship.s3Text": "E-Mail mit Sendungsnummer und Link zum Transporteur.",
  "ship.s4": "Lieferung",
  "ship.s4Text": "Nach Hause, in die Werkstatt oder an einen Paketshop – ganz nach Wunsch.",
  "ship.carriers": "Unsere Transporteure",
  "ship.c1Delay": "2–4 Werktage",
  "ship.c1Note": "Lieferung nach Hause oder in die Postfiliale",
  "ship.c2Delay": "24–48 h",
  "ship.c2Note": "Express, ideal für dringende Werkstattfälle",
  "ship.c3Delay": "2–3 Werktage",
  "ship.c3Note": "Sperrige Pakete (Stoßstangen, Motorhauben…)",
  "ship.c4Delay": "3–5 Werktage",
  "ship.c4Note": "Abholung im Paketshop, günstig",
  "ship.trackingKicker": "Sendungsverfolgung",
  "ship.trackingTitle": "Wo ist meine Bestellung?",
  "ship.trackingText": "Status, Transporteur und Sendungsnummer finden Sie in Ihrem Kundenkonto.",
  "ship.trackCta": "Meine Bestellung verfolgen",
  "cat.metaSubFallback": "{sub} ({cat}) zum besten Preis auf OTOPIECES.COM: {brands}, garantierte Kompatibilität mit Ihrem Fahrzeug, Lieferung in 2-5 Tagen, 14 Tage Rückgabe.",
  "cat.metaFallback": "Kaufen Sie Ihre {cat}-Teile zum besten Preis auf OTOPIECES.COM: große Marken ({brands}), garantierte Kompatibilität mit Ihrem Fahrzeug, Lieferung in 2-5 Tagen.",
  "vg.today": "heute",
  "vg.budgetInline": "Wartungsbudget ~{m} €/Jahr",
  "vg.engines": "Motorisierungen {m}",
  "vg.allN": "Alle ({n})",
  "vg.popular": "Beliebt",
  "vg.engAbbr": "{n} Mot.",
  "vg.choose": "Wählen",
  "vg.parts": "Teile",
  "vg.seeParts": "Alle passenden Teile für {m} anzeigen",
  "vg.allModels": "Alle {b}-Modelle",
  "vg.searchModel": "Modell suchen…",
  "vg.gallery": "Galerie",
  "vg.list": "Liste",
  "vg.noMatch": "Kein Modell entspricht „{q}“.",
  "vg.popularTitle": "Meistgesuchte {b}-Modelle",
  "vg.popularByUsage": "Basierend auf den Auswahlen und Garagen unserer Kunden.",
  "vg.popularByParts": "Modelle mit den meisten verfügbaren Teilen.",
  "vg.generations": { "one": "{n} Generation", "other": "{n} Generationen" },
  "vg.yearsEstimated": "* ungefähre Baujahre",
  "mb.title": "Geschätztes jährliches Wartungsbudget — {car}",
  "mb.intro": "Schätzung auf Basis der {n} gelisteten passenden Verschleißteile ({p} von {pt} Posten), alle Motorisierungen zusammen: Medianpreis oder „Eco“ mit dem günstigsten Teil, bezogen auf die übliche Wechselhäufigkeit.",
  "mb.eco": "Eco: {v} / Jahr",
  "mb.hideDetail": "Details ausblenden",
  "mb.showDetail": "Details pro Posten anzeigen",
  "mb.rankingLink": "Ranking der günstigsten Modelle im Unterhalt ansehen",
  "mb.garageLink": "Fügen Sie dieses Fahrzeug Ihrer Garage hinzu – für ein Budget zu Ihrer exakten Motorisierung und ein Serviceheft",
  "mb.colItem": "Posten",
  "mb.colFreq": "Häufigkeit",
  "mb.colEco": "Eco",
  "mb.colMedian": "Medianpreis",
  "mb.colYear": "Pro Jahr",
  "mb.every": { "one": "jedes Jahr", "other": "alle {n} Jahre" },
  "mb.missing": "Nicht geschätzt (noch kein passendes Teil): {list}",
  "val.cta": "Bei neuen Teilen benachrichtigen",
  "val.activated": "Benachrichtigung aktiviert ({f}{e})!",
  "val.weeklyShort": "Wochenübersicht",
  "val.instantShort": "bei jeder Ergänzung",
  "val.already": "Benachrichtigung bereits aktiv",
  "val.active": "Benachrichtigung für neue Teile aktiv",
  "val.disable": "Deaktivieren",
  "val.formTitle": "E-Mail erhalten, wenn neue passende Teile hinzugefügt werden",
  "val.emailPh": "ihre@email.de",
  "val.enable": "Aktivieren",
  "val.onlyEngine": "Nur meine Motorisierung",
  "val.weekly": "Wochenübersicht (montags)",
  "val.instant": "Bei jeder Ergänzung",
  "val.error": "Benachrichtigung konnte nicht aktiviert werden, bitte E-Mail-Adresse prüfen.",
  "val.notifyWhenAdded": "Benachrichtigen, sobald ein Teil hinzugefügt wird",
  "gar.alertEnabledNote": "Benachrichtigung „neue Teile“ aktiviert (Wochenübersicht).",
  "gar.alertOptIn": "Per E-Mail über neue passende Teile für dieses Fahrzeug informieren",
  "gar.alertOptInHint": "(Wochenübersicht, änderbar unter Meine Benachrichtigungen)",
  "vb.brandMeta": "{b} Ersatzteile: {m} Modelle ({fams}…) und {p} passende Teile zum besten Preis. Bremsen, Filter, Motor, Reifen.",
  "vb.partsInCat": "{b} {c} Teile ({n})",
  "vb.allParts": "Alle Teile",
  "vb.noPartsInCat": "Noch keine Teile dieser Kategorie für diese Marke.",
  "vb.modelFilter": "Nach Modell filtern",
  "vb.allModelsOpt": "Alle Modelle",
  "vb.partsForModel": "Passende Teile für {b} ({n})",
  "vb.modelPage": "Modellseite",
  "vb.noPartsForModel": "Noch keine Teile dieser Kategorie passend zu diesem Modell.",
  "vb.modelsWithParts": "Modelle mit gelisteten Teilen",
  "vb.modelsOther": "Weitere Modelle",
  "vb.engineFilter": "Nach Motorisierung filtern",
  "vb.allEnginesOpt": "Alle Motorisierungen",
  "fuel.essence": "Benzin", "fuel.diesel": "Diesel", "fuel.hybride": "Hybrid", "fuel.essence/électrique": "Benzin-Hybrid", "fuel.diesel/électrique": "Diesel-Hybrid", "fuel.électrique": "Elektro", "fuel.gpl": "Autogas (LPG)",
  "fuel.essence/gpl": "Benzin / Autogas", "fuel.essence/éthanol": "Benzin / Ethanol",
  "vb.garageAdd": "Zu meiner Garage hinzufügen",
  "vb.garageSee": "In meiner Garage — ansehen",
  "vb.garageAdded": "{car} wurde Ihrer Garage hinzugefügt.",
  "vb.garageAlready": "Dieses Fahrzeug ist bereits in Ihrer Garage.",
  "vb.garageError": "Fahrzeug konnte nicht hinzugefügt werden.",
  "vb.garageLoginHint": "Melden Sie sich an, um dieses Fahrzeug in Ihrer Garage zu speichern",
  "vb.alertCta": "Bei neuen Teilen für {m} benachrichtigen",
  "vb.share": "Diese Auswahl teilen",
  "vb.shareText": "Passende Teile {sel} auf OTOPIECES.COM",
  "vb.shareCopied": "Link zur Auswahl in die Zwischenablage kopiert.",
  "vb.shareCopiedShort": "Link kopiert",
  "vb.shareCopyManual": "Diesen Link kopieren:",
  "vb.shareCheapest": "Die 3 günstigsten Teile:",
  "vb.shareWhatsappHint": "Auswahl und die 3 günstigsten Teile per WhatsApp senden",
  "fuelR.title": "Kraftstoff",
  "fuelR.all": "Alle Antriebe",
  "fuelR.essence": "Benzin",
  "fuelR.diesel": "Diesel",
  "fuelR.electrique": "100 % elektrisch",
  "fuelR.reserved": "Nur für Motoren:",
  "fuelR.vehicleHint": "Relevanz: {e}-Teile für Ihr Fahrzeug zuerst",
  "product.fitFuelKo": "Nur für {e}-Motoren — Ihr Fahrzeug ist {ve}",
  "cart.fitFuel": "Nur {e} · Ihr {v} ist {ve}",
  "garage.additivesTitle": "Empfohlene Additive",
  "garage.additivesHint": "Additive und Reiniger passend zum Antrieb jedes Ihrer Fahrzeuge.",
  "garage.additivesEmpty": "Noch kein passendes Additiv.",
  "garage.additiveHint": "Denken Sie an das Additiv:",
  "packEss.title": "Wartungspaket Benzin",
  "packEss.onAdditive": "auf das Additiv",
  "packEss.desc": "Dieses Öl + ein Benzin-Kraftstoffadditiv: -{p} % auf das Additiv, Rabatt wird an der Kasse automatisch angewendet.",
  "packEss.total": "Das Paket:",
  "packEss.add": "Paket in den Warenkorb",
  "packEss.done": "Paket hinzugefügt",
  "packEss.added": "Paket im Warenkorb — Code {c} angewendet",
  "packEss.addedLogin": "Paket hinzugefügt — der Rabatt {c} gilt an der Kasse nach der Anmeldung",
  "packEss.code": "Rabatt über den Code {c}, gültig mit einem Motoröl im Warenkorb.",
  "packEss.titleDiesel": "Wartungspaket Diesel",
  "packEss.descDiesel": "Dieses Öl + ein Diesel-Additiv oder DPF-Reiniger: -{p} % auf das Additiv, Rabatt wird an der Kasse automatisch angewendet.",
  "packEss.cartDesc": "Ihr Motoröl liegt allein im Warenkorb: vervollständigen Sie das Paket mit dem passenden Additiv, -{p} % darauf.",
  "packEss.cartAdd": "Additiv zum Paket hinzufügen (-{p} %)",
};

export default de;
